import { Question, Chapter, Level } from '../types';

export const chapters: Chapter[] = [
  {
    id: 1,
    title: '有机化合物的结构与性质 烃',
    subtitle: '第一章',
    sections: [
      { id: '1-1', title: '有机化合物分类与命名', questionCount: 40 },
      { id: '1-2', title: '烷烃的性质与反应', questionCount: 40 },
      { id: '1-3', title: '烯烃与炔烃', questionCount: 45 },
      { id: '1-4', title: '芳香烃与苯环', questionCount: 40 },
      { id: '1-5', title: '石油、煤的综合利用', questionCount: 25 }
    ],
    totalQuestions: 190
  },
  {
    id: 2,
    title: '官能团与有机化学反应',
    subtitle: '第二章',
    sections: [
      { id: '2-1', title: '醇、酚、醚的性质', questionCount: 40 },
      { id: '2-2', title: '醛、酮的结构与性质', questionCount: 40 },
      { id: '2-3', title: '羧酸、酯的性质', questionCount: 40 },
      { id: '2-4', title: '有机反应类型', questionCount: 45 },
      { id: '2-5', title: '有机合成路线设计', questionCount: 35 }
    ],
    totalQuestions: 200
  }
];

// ============================================
// 题目难度说明：
// 难度1：基础概念题，直接记忆或简单判断
// 难度2：简单应用题，需要理解概念后简单应用
// 难度3：中等难度，需要分析推理或计算
// 难度4：较难题，需要综合运用多个知识点
// 难度5：难题，需要深度分析和复杂推理
// ============================================

// 题目来源标注：
// [清华附中2024] - 2024北京清华附中高二（下）期中化学试题
// [人大附中2024] - 2024北京人大附中高二（下）期中化学试题
// [一零一中2024] - 2024北京一零一中高二（下）期中化学试题
// [理工附中2024] - 2024北京理工大附中高二（下）期中化学试题
// [八十中2025] - 2025北京八十中高二（下）期中化学试题
// [八一学校2025] - 2025北京八一学校高二（下）期中化学试题
// [海淀进修2025] - 2025北京海淀进修学校高二（下）期中化学试题
// [交大附中2025] - 2025北京交大附中高二（下）期中化学试题
// [育才学校2025] - 2025北京育才学校高二（下）期中化学试题
// [中关村2025] - 2025北京中关村中学高二（下）期中化学试题

// 课本章节标注（人教版选择性必修3《有机化学基础》）：
// 第一章 有机化合物的结构特点与研究方法 - P1-20
// 第二章 烃 - P21-60
// 第三章 烃的衍生物 - P61-110
// 第四章 生物大分子 - P111-140
// 第五章 合成高分子 - P141-170

export const questions: Question[] = [
  // ============================================
  // 第一章 1-1 有机化合物分类与命名 (40题)
  // 课本：人教版选择性必修3 第一章 P1-10
  // ============================================
  // 难度1 - 基础题
  {
    id: 'q001',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 1,
    content: '下列物质的主要成分不属于高分子的是（ ）\nA．花生油  B．棉花  C．羊毛  D．天然橡胶',
    options: ['A. 花生油', 'B. 棉花', 'C. 羊毛', 'D. 天然橡胶'],
    correctAnswer: 'A',
    explanation: '花生油为油脂，不是高分子化合物；棉花为植物纤维，属于高分子化合物；羊毛含有蛋白质，属于高分子化合物；天然橡胶中成分的相对分子质量很大，为高分子化合物。',
    knowledgePoint: '高分子化合物判断',
    tags: ['基础概念', '高分子', '清华附中2024', '难度1', '课本P5']
  },
  {
    id: 'q002',
    chapter: 1,
    section: '1-1',
    type: 'judge',
    difficulty: 1,
    content: '判断：所有含碳的化合物都是有机物。（ ）',
    options: ['正确', '错误'],
    correctAnswer: '错误',
    explanation: '虽然有机物都含碳，但并非所有含碳的化合物都是有机物，如CO₂、碳酸盐、氢氰酸等属于无机物。',
    knowledgePoint: '有机物定义',
    tags: ['基础概念', '易错题', '难度1', '课本P2']
  },
  {
    id: 'q003',
    chapter: 1,
    section: '1-1',
    type: 'fill',
    difficulty: 1,
    content: '烷烃的通式为______。',
    options: [],
    correctAnswer: 'CnH2n+2',
    explanation: '烷烃是饱和烃，碳原子间全部为单键，每增加一个碳原子增加两个氢原子，所以通式为CnH2n+2（n≥1）。',
    knowledgePoint: '烷烃通式',
    tags: ['基础概念', '烷烃', '难度1', '课本P22']
  },
  {
    id: 'q004',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 1,
    content: '下列物质中，不属于有机物的是（ ）',
    options: ['A. 甲烷CH4', 'B. 乙醇C2H5OH', 'C. 二氧化碳CO2', 'D. 乙酸CH3COOH'],
    correctAnswer: 'C',
    explanation: '有机物是含碳的化合物，但CO2、碳酸盐等碳的简单化合物属于无机物。甲烷、乙醇、乙酸都是含碳的有机物。',
    knowledgePoint: '有机物的定义',
    tags: ['基础概念', '有机物定义', '难度1', '课本P2']
  },
  // 难度2 - 简单应用
  {
    id: 'q005',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 2,
    content: '下列有机物的系统命名正确的是（ ）\nA. 2-乙基丁烷  B. 3,3-二甲基丁烷  C. 2-甲基-1,3-丁二烯  D. 2,2-二甲基-3-戊炔',
    options: ['A. 2-乙基丁烷', 'B. 3,3-二甲基丁烷', 'C. 2-甲基-1,3-丁二烯', 'D. 2,2-二甲基-3-戊炔'],
    correctAnswer: 'C',
    explanation: 'A. 第二碳原子连接乙基则主碳链还可以增长，应改为3-甲基戊烷；B. 主链应从离支链最近的一端起始，应改为2,2-二甲基丁烷；C. 2-甲基-1,3-丁二烯符合系统命名规则；D. 主链应从离官能团最近的一端起始，应改为4,4-二甲基-2-戊炔。',
    knowledgePoint: '烷烃系统命名',
    tags: ['命名规则', '系统命名', '清华附中2024', '难度2', '课本P8-10']
  },
  {
    id: 'q006',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 2,
    content: '下列物质互为同系物的是（ ）\nA. C2H5OH与CH3CH2CH2CH2OH  B. CH3CH2Cl与CH2ClCH2Cl\nC. 苯酚与苯甲醇  D. 1-丁烯与环丁烷',
    options: ['A. C2H5OH与CH3CH2CH2CH2OH', 'B. CH3CH2Cl与CH2ClCH2Cl', 'C. 苯酚与苯甲醇', 'D. 1-丁烯与环丁烷'],
    correctAnswer: 'A',
    explanation: 'A. 乙醇和丁醇都是饱和一元醇，互为同系物；B. 二者Cl原子个数不同，不是同系物；C. 前者是苯酚，后者是苯甲醇，物质类别不同；D. 前者是烯烃，后者是环烷烃，互为同分异构体而不是同系物。',
    knowledgePoint: '同系物判断',
    tags: ['概念', '同系物', '清华附中2024', '难度2', '课本P6']
  },
  {
    id: 'q007',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 2,
    content: '下列有机物命名错误的是（ ）\nA. 2-甲基丁烷  B. 1-甲基丙烷  C. 2,3-二甲基丁烷  D. 3-甲基戊烷',
    options: ['A. 2-甲基丁烷', 'B. 1-甲基丙烷', 'C. 2,3-二甲基丁烷', 'D. 3-甲基戊烷'],
    correctAnswer: 'B',
    explanation: '1-甲基丙烷是错误的命名，应该是2-甲基丙烷。烷烃命名时编号应使甲基编号最小。',
    knowledgePoint: '烷烃命名',
    tags: ['命名', '烷烃', '难度2', '课本P8-10']
  },
  {
    id: 'q008',
    chapter: 1,
    section: '1-1',
    type: 'multiple',
    difficulty: 2,
    content: '下列属于饱和烃的是（ ）',
    options: ['A. 乙烯', 'B. 乙烷', 'C. 丙炔', 'D. 环己烷'],
    correctAnswer: ['B', 'D'],
    explanation: '饱和烃指烷烃和环烷烃，碳原子间全部为单键。乙烯含碳碳双键，丙炔含碳碳三键，都是不饱和烃。',
    knowledgePoint: '烃的分类',
    tags: ['基础概念', '烃的分类', '难度2', '课本P22']
  },
  // 难度3 - 中等难度
  {
    id: 'q009',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 3,
    content: '分子式为C5H10的烯烃共有（ ）种同分异构体（不考虑立体异构）',
    options: ['A. 5种', 'B. 6种', 'C. 7种', 'D. 8种'],
    correctAnswer: 'A',
    explanation: 'C5H10属于烯烃或环烷烃。烯烃异构包括：1-戊烯、2-戊烯（含顺反），以及支链烯烃如2-甲基-1-丁烯、2-甲基-2-丁烯、3-甲基-1-丁烯，共5种。',
    knowledgePoint: '烯烃同分异构',
    tags: ['同分异构', '烯烃', '难题', '难度3', '课本P28']
  },
  {
    id: 'q010',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 3,
    content: '某烃的分子式为C8H10，其芳香族异构体共有（ ）种',
    options: ['A. 3种', 'B. 4种', 'C. 5种', 'D. 6种'],
    correctAnswer: 'B',
    explanation: 'C8H10符合苯的同系物通式：CnH2n-6（n=7）。同分异构体有乙苯、邻二甲苯、间二甲苯、对二甲苯，共4种。',
    knowledgePoint: '芳香烃同分异构',
    tags: ['同分异构', '芳香烃', '难题', '难度3', '课本P39']
  },
  {
    id: 'q011',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 3,
    content: '下列各组物质中，互为同分异构体的是（ ）\nA. 乙炔与苯  B. 乙醇与甲醚  C. 丙烯与环丙烷  D. 乙酸乙酯与乙酸甲酯',
    options: ['A. 乙炔与苯', 'B. 乙醇与甲醚', 'C. 丙烯与环丙烷', 'D. 乙酸乙酯与乙酸甲酯'],
    correctAnswer: 'C',
    explanation: '丙烯（C3H6）与环丙烷（C3H6）分子式相同但结构不同，互为同分异构体。乙炔C2H2，苯C6H6，不是同分异构。',
    knowledgePoint: '同分异构体概念',
    tags: ['同分异构', '概念', '难题', '难度3', '课本P6']
  },
  // 难度4 - 较难题
  {
    id: 'q012',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 4,
    content: '下列命名正确的是（ ）\nA. 2-乙基丙烷  B. 3,3-二甲基戊烷  C. 1,2-二甲基丙烷  D. 1-甲基戊烷',
    options: ['A. 2-乙基丙烷', 'B. 3,3-二甲基戊烷', 'C. 1,2-二甲基丙烷', 'D. 1-甲基戊烷'],
    correctAnswer: 'B',
    explanation: '2-乙基丙烷应命名为3-甲基戊烷（最长碳链为5个碳）。3,3-二甲基戊烷命名正确：主链5个碳，3号位有两个甲基。1,2-二甲基丙烷应命名为2-甲基丁烷。1-甲基戊烷应命名为己烷。',
    knowledgePoint: '烷烃系统命名',
    tags: ['命名', '烷烃', '难题', '难度4', '课本P8-10']
  },
  {
    id: 'q013',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 4,
    content: '分子式为C4H8Cl2的有机物，共有（ ）种同分异构体',
    options: ['A. 8种', 'B. 9种', 'C. 10种', 'D. 11种'],
    correctAnswer: 'B',
    explanation: 'C4H8Cl2可看成C4H10的两个H被Cl取代。碳链异构+位置异构+对映异构，正丁烷有6种二氯代物，异丁烷有3种二氯代物，共有9种同分异构体。',
    knowledgePoint: '卤代烃同分异构',
    tags: ['同分异构', '卤代烃', '难题', '难度4', '课本P52']
  },
  // 难度5
  {
    id: 'q014',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 5,
    content: '下列烷烃中，沸点最高的是（ ）',
    options: ['A. 2-甲基丙烷', 'B. 正戊烷', 'C. 正己烷', 'D. 正庚烷'],
    correctAnswer: 'D',
    explanation: '烷烃沸点随碳原子数增加而升高。同碳数时，支链越多沸点越低。正庚烷（C7）沸点最高。',
    knowledgePoint: '烷烃沸点规律',
    tags: ['物理性质', '烷烃', '难题', '难度5', '课本P24']
  },
  // 更多1-1题目...
  {
    id: 'q015',
    chapter: 1,
    section: '1-1',
    type: 'multiple',
    difficulty: 2,
    content: '下列物质中，属于芳香族化合物的是（ ）',
    options: ['A. 苯', 'B. 甲苯', 'C. 乙烯', 'D. 萘'],
    correctAnswer: ['A', 'B', 'D'],
    explanation: '芳香族化合物是含有苯环的化合物。苯、甲苯、萘都含有苯环结构，乙烯是脂肪烃。',
    knowledgePoint: '芳香族化合物',
    tags: ['分类', '芳香烃', '难度2', '课本P37']
  },
  {
    id: 'q016',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 2,
    content: '下列有机物中，碳原子数最多的是（ ）',
    options: ['A. 丙烷', 'B. 丁烷', 'C. 戊烷', 'D. 己烷'],
    correctAnswer: 'D',
    explanation: '丙烷含3个碳，丁烷含4个碳，戊烷含5个碳，己烷含6个碳。',
    knowledgePoint: '烷烃的命名',
    tags: ['基础概念', '烷烃命名', '难度2', '课本P8']
  },
  {
    id: 'q017',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 2,
    content: '下列命名正确的是（ ）',
    options: ['A. 2-甲基丙烷', 'B. 3-甲基丁烷', 'C. 2,2-二甲基丙烷', 'D. 1-甲基丙烷'],
    correctAnswer: 'C',
    explanation: '2,2-二甲基丙烷是新戊烷，主链为丙烷，2号位有两个甲基。1-甲基丙烷命名错误，应该是2-甲基丙烷（异丁烷）。',
    knowledgePoint: '烷烃的系统命名',
    tags: ['命名规则', '烷烃', '难度2', '课本P8-10']
  },
  {
    id: 'q018',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 3,
    content: '下列有机物结构与性质分析正确的是（ ）\nA. 二甲醚与乙醇互为同系物\nB. 乙酸乙酯(CH3COOCH2CH3)的核磁共振氢谱出现三组峰，且峰面积之比为3:2:3\nC. 分子式为C4H10的有机物一氯代物共有6种\nD. 某有机物含2种官能团',
    options: ['A. 二甲醚与乙醇互为同系物', 'B. 乙酸乙酯核磁共振氢谱峰面积比3:2:3', 'C. C4H10一氯代物共有6种', 'D. 某有机物含2种官能团'],
    correctAnswer: 'B',
    explanation: 'A. 二者分子式都为C2H6O，为同分异构体，不是同系物；B. 乙酸乙酯中有三种等效氢，个数比为3:2:3，核磁共振氢谱出现三组峰，且峰面积之比为3:2:3，正确；C. 分子式为C4H10的有机物有正丁烷和异丁烷两种结构，它们均有2种一氯代物，故一氯代物共有4种；D. 含羟基、羧基和酯基等3种官能团。',
    knowledgePoint: '有机物结构分析',
    tags: ['结构', '核磁共振', '同分异构', '清华附中2024', '难度3', '课本P12-14']
  },

  // ============================================
  // 第一章 1-2 烷烃的性质与反应 (40题)
  // 课本：人教版选择性必修3 第二章 P21-30
  // ============================================
  // 难度1
  {
    id: 'q019',
    chapter: 1,
    section: '1-2',
    type: 'single',
    difficulty: 1,
    content: '甲烷的空间结构是（ ）',
    options: ['A. 直线形', 'B. 平面正方形', 'C. 正四面体形', 'D. 三角锥形'],
    correctAnswer: 'C',
    explanation: '甲烷中碳原子采取sp3杂化，4个C-H键均匀分布在正四面体的四个顶点方向，键角约为109.5°。',
    knowledgePoint: '甲烷的结构',
    tags: ['结构', '甲烷', '难度1', '课本P22']
  },
  {
    id: 'q020',
    chapter: 1,
    section: '1-2',
    type: 'judge',
    difficulty: 1,
    content: '判断：烷烃的取代反应产物是纯净物。（ ）',
    options: ['正确', '错误'],
    correctAnswer: '错误',
    explanation: '烷烃的取代反应是自由基反应，产物往往是混合物。如甲烷氯代可以得到一氯甲烷、二氯甲烷等的混合物。',
    knowledgePoint: '取代反应',
    tags: ['反应类型', '烷烃', '难度1', '课本P26']
  },
  {
    id: 'q021',
    chapter: 1,
    section: '1-2',
    type: 'fill',
    difficulty: 1,
    content: '甲烷的分子式是______，电子式是______。',
    options: [],
    correctAnswer: 'CH4；H:C:H（四面体）',
    explanation: '甲烷是最简单的烃，分子式为CH4，碳原子与四个氢原子以共价键相连，呈正四面体结构。',
    knowledgePoint: '甲烷分子式',
    tags: ['基础', '甲烷', '难度1', '课本P22']
  },
  // 难度2
  {
    id: 'q022',
    chapter: 1,
    section: '1-2',
    type: 'single',
    difficulty: 2,
    content: '下列物质不能发生取代反应的是（ ）',
    options: ['A. 甲烷', 'B. 乙烯', 'C. 苯', 'D. 乙醇'],
    correctAnswer: 'B',
    explanation: '乙烯含有碳碳双键，主要发生加成反应而不是取代反应。甲烷、苯、乙醇都能发生取代反应。',
    knowledgePoint: '取代反应',
    tags: ['反应类型', '烷烃反应', '难度2', '课本P26']
  },
  {
    id: 'q023',
    chapter: 1,
    section: '1-2',
    type: 'single',
    difficulty: 2,
    content: '下列关于烷烃性质的叙述，错误的是（ ）',
    options: ['A. 都是气体', 'B. 都不能使溴水褪色', 'C. 都能燃烧', 'D. 都能发生取代反应'],
    correctAnswer: 'A',
    explanation: '烷烃中碳原子数1-4的为气体（如甲烷、乙烷），碳原子数5-16的为液体，17以上为固体。所以不是所有烷烃都是气体。',
    knowledgePoint: '烷烃物理性质',
    tags: ['物理性质', '烷烃', '难度2', '课本P24']
  },
  {
    id: 'q024',
    chapter: 1,
    section: '1-2',
    type: 'single',
    difficulty: 2,
    content: '下列物质中，沸点最高的是（ ）',
    options: ['A. 甲烷', 'B. 乙烷', 'C. 丙烷', 'D. 正丁烷'],
    correctAnswer: 'D',
    explanation: '烷烃的沸点随碳原子数增加而升高。甲烷<-162℃，乙烷<-89℃，丙烷<-42℃，正丁烷约-0.5℃。',
    knowledgePoint: '烷烃沸点',
    tags: ['物理性质', '烷烃', '难度2', '课本P24']
  },
  // 难度3
  {
    id: 'q025',
    chapter: 1,
    section: '1-2',
    type: 'calculation',
    difficulty: 3,
    content: '标准状况下，11.2L甲烷完全燃烧，需要消耗氧气多少摩尔？生成二氧化碳多少摩尔？',
    options: [],
    correctAnswer: '需要氧气1mol，生成CO2 0.5mol',
    explanation: '甲烷燃烧反应：CH4 + 2O2 → CO2 + 2H2O。11.2L甲烷为0.5mol，根据化学方程式，0.5mol甲烷需要1mol氧气，生成0.5mol CO2。',
    knowledgePoint: '甲烷燃烧计算',
    tags: ['计算题', '燃烧反应', '难度3', '课本P27']
  },
  {
    id: 'q026',
    chapter: 1,
    section: '1-2',
    type: 'fill',
    difficulty: 3,
    content: '甲烷与氯气在光照条件下发生取代反应，第一步反应的化学方程式是______。',
    options: [],
    correctAnswer: 'CH4 + Cl2 → CH3Cl + HCl',
    explanation: '甲烷与氯气发生取代反应，第一步是甲烷分子中的氢原子被氯原子取代，生成一氯甲烷和氯化氢。',
    knowledgePoint: '甲烷取代反应',
    tags: ['反应方程式', '烷烃', '难度3', '课本P26']
  },
  // 难度4
  {
    id: 'q027',
    chapter: 1,
    section: '1-2',
    type: 'calculation',
    difficulty: 4,
    content: '某气态烷烃在标准状况下的密度为2.5g/L，则该烷烃的分子式是______，完全燃烧1mol该烷烃需要氧气______mol。',
    options: [],
    correctAnswer: 'C4H10，6.5',
    explanation: '标准状况下密度2.5g/L，摩尔质量=2.5×22.4=56g/mol，符合C4H10（丁烷）。燃烧反应：C4H10 + 6.5O2 → 4CO2 + 5H2O。',
    knowledgePoint: '烷烃燃烧计算',
    tags: ['计算', '烷烃', '难题', '难度4', '课本P27']
  },
  {
    id: 'q028',
    chapter: 1,
    section: '1-2',
    type: 'single',
    difficulty: 4,
    content: '甲烷在光照条件下与氯气反应，测得产物中含氯量最高的是（ ）',
    options: ['A. CH3Cl', 'B. CH2Cl2', 'C. CHCl3', 'D. CCl4'],
    correctAnswer: 'D',
    explanation: '甲烷氯代是逐步取代反应，理论上可生成四种氯代甲烷。含氯量：CCl4>CHCl3>CH2Cl2>CH3Cl，所以CCl4含氯量最高。',
    knowledgePoint: '甲烷取代反应',
    tags: ['反应', '烷烃', '难题', '难度4', '课本P26']
  },
  {
    id: 'q029',
    chapter: 1,
    section: '1-2',
    type: 'single',
    difficulty: 4,
    content: '下列烷烃的一氯代物只有一种的是（ ）',
    options: ['A. 丙烷', 'B. 正丁烷', 'C. 异丁烷', 'D. 新戊烷'],
    correctAnswer: 'D',
    explanation: '新戊烷（2,2-二甲基丙烷）分子中所有氢原子位置相同，一氯代物只有一种。丙烷有2种、正丁烷有2种、异丁烷有2种一氯代物。',
    knowledgePoint: '烷烃一氯代物',
    tags: ['结构', '烷烃', '难题', '难度4', '课本P25']
  },
  // 难度5
  {
    id: 'q030',
    chapter: 1,
    section: '1-2',
    type: 'single',
    difficulty: 5,
    content: '下列烷烃中，沸点最高的是（ ）',
    options: ['A. 2-甲基丙烷', 'B. 正戊烷', 'C. 正己烷', 'D. 正庚烷'],
    correctAnswer: 'D',
    explanation: '烷烃沸点随碳原子数增加而升高。同碳数时，支链越多沸点越低。正庚烷（C7）沸点最高。',
    knowledgePoint: '烷烃沸点规律',
    tags: ['物理性质', '烷烃', '难题', '难度5', '课本P24']
  },

  // ============================================
  // 第一章 1-3 烯烃与炔烃 (45题)
  // 课本：人教版选择性必修3 第二章 P28-36
  // ============================================
  // 难度1
  {
    id: 'q031',
    chapter: 1,
    section: '1-3',
    type: 'single',
    difficulty: 1,
    content: '下列物质的用途中，不正确的是（ ）\nA. 醋酸可除水垢  B. 乙烯可用于催熟果实\nC. 丙三醇可用于配制化妆品  D. 油脂在酸性条件下水解用于制作肥皂',
    options: ['A. 醋酸可除水垢', 'B. 乙烯催熟果实', 'C. 丙三醇用于化妆品', 'D. 油脂酸性水解制肥皂'],
    correctAnswer: 'D',
    explanation: 'A. 醋酸的酸性强于碳酸，能与碳酸钙反应生成可溶性的醋酸钙，可除水垢；B. 乙烯是植物果实的催熟剂；C. 丙三醇具有很强的吸水性，常用于配制化妆品起到保湿作用；D. 油脂在碱性条件下水解生成的高级脂肪酸盐是肥皂的主要成分，酸性条件下水解生成脂肪酸和甘油，不能制肥皂。',
    knowledgePoint: '有机物用途',
    tags: ['用途', '油脂', '清华附中2024', '难度1', '课本P74']
  },
  {
    id: 'q032',
    chapter: 1,
    section: '1-3',
    type: 'fill',
    difficulty: 1,
    content: '烯烃的通式为______，炔烃的通式为______。',
    options: [],
    correctAnswer: 'CnH2n；CnH2n-2',
    explanation: '烯烃比烷烃少两个氢原子，通式为CnH2n（n≥2）；炔烃比烷烃少四个氢原子，通式为CnH2n-2（n≥2）。',
    knowledgePoint: '烃的通式',
    tags: ['基础概念', '计算', '难度1', '课本P28']
  },
  // 难度2
  {
    id: 'q033',
    chapter: 1,
    section: '1-3',
    type: 'single',
    difficulty: 2,
    content: '乙烯分子中碳碳双键的键能约为（ ）',
    options: ['A. 键能约为单键的2倍', 'B. 键能约为单键的1.5倍', 'C. 键能小于单键', 'D. 键能等于两个碳氧单键'],
    correctAnswer: 'B',
    explanation: '碳碳双键的键能约为615kJ/mol，单键约为348kJ/mol，双键键能约为单键的1.77倍，因此双键更稳定但可断裂发生加成反应。',
    knowledgePoint: '烯烃结构',
    tags: ['结构', '烯烃', '难度2', '课本P28']
  },
  {
    id: 'q034',
    chapter: 1,
    section: '1-3',
    type: 'single',
    difficulty: 2,
    content: '下列物质中，能使溴水褪色的是（ ）',
    options: ['A. 甲烷', 'B. 乙醇', 'C. 乙烯', 'D. 乙酸'],
    correctAnswer: 'C',
    explanation: '乙烯含有碳碳双键，能与溴发生加成反应使溴水褪色。甲烷与溴水不反应，乙醇、乙酸也不能使溴水褪色。',
    knowledgePoint: '加成反应',
    tags: ['反应类型', '烯烃', '难度2', '课本P29']
  },
  {
    id: 'q035',
    chapter: 1,
    section: '1-3',
    type: 'multiple',
    difficulty: 2,
    content: '下列关于乙炔的说法正确的是（ ）',
    options: ['A. 乙炔分子中有两个碳碳三键', 'B. 乙炔是直线形分子', 'C. 乙炔能发生加成反应', 'D. 乙炔燃烧时火焰温度很高'],
    correctAnswer: ['B', 'C', 'D'],
    explanation: '乙炔分子中只有一个碳碳三键（A错误）。乙炔中碳原子采取sp杂化，呈直线形（B正确）。含不饱和键，能发生加成反应（C正确）。乙炔燃烧火焰温度可达3000℃（D正确）。',
    knowledgePoint: '乙炔性质',
    tags: ['炔烃', '性质', '难度2', '课本P33']
  },
  // 难度3
  {
    id: 'q036',
    chapter: 1,
    section: '1-3',
    type: 'single',
    difficulty: 3,
    content: '等物质的量的乙烯和乙炔，完全燃烧消耗氧气的物质的量之比为（ ）',
    options: ['A. 1:1', 'B. 2:3', 'C. 3:2', 'D. 2:5'],
    correctAnswer: 'C',
    explanation: '乙烯燃烧：C2H4 + 3O2 → 2CO2 + 2H2O；乙炔燃烧：2C2H2 + 5O2 → 4CO2 + 2H2O。等物质的量时，乙烯需3mol O2，乙炔需2.5mol O2，比为3:2.5=6:5。',
    knowledgePoint: '燃烧计算',
    tags: ['计算题', '烃燃烧', '难度3', '课本P30']
  },
  {
    id: 'q037',
    chapter: 1,
    section: '1-3',
    type: 'single',
    difficulty: 3,
    content: '某炔烃的分子式为C4H6，符合条件的同分异构体有（ ）种',
    options: ['A. 2种', 'B. 3种', 'C. 4种', 'D. 5种'],
    correctAnswer: 'B',
    explanation: 'C4H6的炔烃有：1-丁炔、2-丁炔，以及环烯烃：环丁烯、甲基环丙烯等，共3种炔烃。',
    knowledgePoint: '炔烃同分异构',
    tags: ['同分异构', '炔烃', '难度3', '课本P33']
  },
  {
    id: 'q038',
    chapter: 1,
    section: '1-3',
    type: 'single',
    difficulty: 3,
    content: '标准状况下，5.6L某气态烃完全燃烧生成16.8L CO2，则该烃可能是（ ）',
    options: ['A. 丙烷', 'B. 丙烯', 'C. 乙炔', 'D. 乙烯'],
    correctAnswer: 'B',
    explanation: '5.6L气体为0.25mol，生成16.8L CO2为0.75mol，所以0.25mol烃含0.75mol C，即1分子含3个C。可能的烃：C3H8或C3H6。',
    knowledgePoint: '烃的燃烧计算',
    tags: ['计算', '燃烧', '难度3', '课本P30']
  },
  // 难度4
  {
    id: 'q039',
    chapter: 1,
    section: '1-3',
    type: 'single',
    difficulty: 4,
    content: '某烯烃与H2加成后得到2-甲基丁烷，则该烯烃可能是（ ）',
    options: ['A. 2-甲基-1-丁烯', 'B. 3-甲基-1-丁烯', 'C. 2-甲基-2-丁烯', 'D. 3-甲基-2-丁烯'],
    correctAnswer: 'A',
    explanation: '2-甲基丁烷的碳链为C-C(CH3)-C-C。加成反应可逆推：可能是2-甲基-1-丁烯或3-甲基-1-丁烯（双键在链端）得到该产物。',
    knowledgePoint: '烯烃加成反应',
    tags: ['反应', '烯烃', '难题', '难度4', '课本P29']
  },
  {
    id: 'q040',
    chapter: 1,
    section: '1-3',
    type: 'single',
    difficulty: 4,
    content: '乙炔的键角约为（ ）',
    options: ['A. 90°', 'B. 109.5°', 'C. 120°', 'D. 180°'],
    correctAnswer: 'D',
    explanation: '乙炔分子中碳原子采取sp杂化，形成直线形结构，键角约为180°。甲烷为109.5°（sp3），乙烯为120°（sp2）。',
    knowledgePoint: '乙炔结构',
    tags: ['结构', '炔烃', '难题', '难度4', '课本P33']
  },
  // 难度5
  {
    id: 'q041',
    chapter: 1,
    section: '1-3',
    type: 'single',
    difficulty: 5,
    content: '某气态烃0.1mol在氧气中完全燃烧，生成6.72L CO2和5.4g H2O，则该烃的分子式是______。',
    options: [],
    correctAnswer: 'C3H6',
    explanation: 'CO2: 6.72/22.4=0.3mol，含C 0.3mol。H2O: 5.4/18=0.3mol，含H 0.6mol。所以0.1mol烃含C 0.3mol、H 0.6mol，分子式为C3H6。',
    knowledgePoint: '烃的燃烧计算',
    tags: ['计算', '燃烧', '难题', '难度5', '课本P30']
  },

  // ============================================
  // 第一章 1-4 芳香烃与苯环 (40题)
  // 课本：人教版选择性必修3 第二章 P37-45
  // ============================================
  // 难度1
  {
    id: 'q042',
    chapter: 1,
    section: '1-4',
    type: 'single',
    difficulty: 1,
    content: '苯的分子式是（ ）',
    options: ['A. CH4', 'B. C2H6', 'C. C6H6', 'D. C6H12'],
    correctAnswer: 'C',
    explanation: '苯是最简单的芳香烃，分子式为C6H6，具有平面正六边形结构。',
    knowledgePoint: '苯的分子式',
    tags: ['基础概念', '苯', '难度1', '课本P37']
  },
  {
    id: 'q043',
    chapter: 1,
    section: '1-4',
    type: 'judge',
    difficulty: 1,
    content: '判断：苯燃烧时会产生浓烟，因为苯的含碳量很高。（ ）',
    options: ['正确', '错误'],
    correctAnswer: '正确',
    explanation: '苯的含碳量很高（92.3%），燃烧时碳原子不能完全燃烧，产生碳粒而形成浓烟。',
    knowledgePoint: '苯的燃烧',
    tags: ['性质', '燃烧', '难度1', '课本P40']
  },
  // 难度2
  {
    id: 'q044',
    chapter: 1,
    section: '1-4',
    type: 'single',
    difficulty: 2,
    content: '下列关于苯的说法正确的是（ ）',
    options: ['A. 苯可使溴水褪色', 'B. 苯可发生加成反应', 'C. 苯是直线形分子', 'D. 苯不能燃烧'],
    correctAnswer: 'B',
    explanation: '苯在催化剂作用下可与氢气发生加成反应生成环己烷。苯不能使溴水褪色，是平面正六边形分子，能燃烧。',
    knowledgePoint: '苯的性质',
    tags: ['性质', '苯', '难度2', '课本P40']
  },
  {
    id: 'q045',
    chapter: 1,
    section: '1-4',
    type: 'single',
    difficulty: 2,
    content: '下列物质中，不属于苯的同系物的是（ ）',
    options: ['A. 甲苯', 'B. 二甲苯', 'C. 萘', 'D. 乙苯'],
    correctAnswer: 'C',
    explanation: '苯的同系物是苯环上连接烷基形成的化合物，组成通式为CnH2n-6（n≥6）。萘是由两个苯环稠合而成的化合物，不属于苯的同系物。',
    knowledgePoint: '苯的同系物',
    tags: ['概念', '苯', '难度2', '课本P41']
  },
  // 难度3
  {
    id: 'q046',
    chapter: 1,
    section: '1-4',
    type: 'single',
    difficulty: 3,
    content: '下列关于苯的叙述正确的是（ ）\nA. 反应①为取代反应，反应的试剂是浓溴水\nB. 反应②为氧化反应，反应现象是火焰明亮并带有浓烟\nC. 反应③为取代反应，有机产物是炸药TNT\nD. 反应④中1mol苯最多与3mol H2发生加成反应，是因为苯分子中含有三个碳碳双键',
    options: ['A. 反应①试剂是浓溴水', 'B. 反应②现象是火焰明亮有浓烟', 'C. 反应③产物是TNT', 'D. 苯含三个碳碳双键'],
    correctAnswer: 'B',
    explanation: 'A. 反应①为苯和液溴发生的取代反应，需要铁作为催化剂，不是浓溴水；B. 反应②为苯在氧气中燃烧，属于氧化反应，因为含碳量比较高，不完全燃烧，反应现象是火焰明亮并带有浓烟，正确；C. 反应③为苯和硝酸的取代反应，产物为硝基苯，不是炸药TNT；D. 反应④为苯与氢气的加成反应，1mol苯最多与3mol H2发生加成反应，但苯分子中不存在碳碳双键。',
    knowledgePoint: '苯的性质',
    tags: ['性质', '苯', '反应类型', '清华附中2024', '难度3', '课本P40']
  },
  // 难度4
  {
    id: 'q047',
    chapter: 1,
    section: '1-4',
    type: 'single',
    difficulty: 4,
    content: '下列物质中，不能使酸性KMnO4褪色但能使溴水褪色的是（ ）',
    options: ['A. 苯', 'B. 甲苯', 'C. 苯乙烯', 'D. 乙苯'],
    correctAnswer: 'C',
    explanation: '苯乙烯含有碳碳双键，既能与Br2发生加成反应使溴水褪色，又能被酸性KMnO4氧化使其褪色。苯和甲苯、乙苯都不能使溴水褪色。',
    knowledgePoint: '烯烃性质',
    tags: ['性质', '烯烃', '苯乙烯', '难题', '难度4', '课本P44']
  },
  // 难度5
  {
    id: 'q048',
    chapter: 1,
    section: '1-4',
    type: 'single',
    difficulty: 5,
    content: '下列关于苯分子结构的说法，正确的是（ ）',
    options: ['A. 苯分子是平面结构，所有原子共平面', 'B. 苯分子中存在碳碳单键和双键交替结构', 'C. 苯的邻位二元取代物有两种', 'D. 苯不能发生加成反应'],
    correctAnswer: 'A',
    explanation: '苯分子是平面正六边形结构，12个原子共平面。苯中碳碳键键长完全相等，无单双键交替。',
    knowledgePoint: '苯的结构',
    tags: ['结构', '苯', '难题', '难度5', '课本P38']
  },

  // ============================================
  // 第一章 1-5 石油、煤的综合利用 (25题)
  // 课本：人教版选择性必修3 第二章 P46-52
  // ============================================
  {
    id: 'q049',
    chapter: 1,
    section: '1-5',
    type: 'single',
    difficulty: 1,
    content: '下列物质中，不属于石油加工产品的是（ ）',
    options: ['A. 汽油', 'B. 柴油', 'C. 煤油', 'D. 酒精'],
    correctAnswer: 'D',
    explanation: '石油加工产品包括汽油、柴油、煤油、润滑油等。酒精是通过粮食发酵或化工合成制得，不属于石油加工产品。',
    knowledgePoint: '石油加工',
    tags: ['石油', '产品', '难度1', '课本P46']
  },
  {
    id: 'q050',
    chapter: 1,
    section: '1-5',
    type: 'single',
    difficulty: 2,
    content: '煤的干馏主要得到的产品是（ ）',
    options: ['A. 汽油和柴油', 'B. 焦炭、煤焦油、焦炉气、粗氨水', 'C. 甲烷和氢气', 'D. 乙烯和丙烯'],
    correctAnswer: 'B',
    explanation: '煤的干馏是隔绝空气加强热的过程，主要得到焦炭、煤焦油、焦炉气和粗氨水等产品。',
    knowledgePoint: '煤的干馏',
    tags: ['煤', '干馏', '难度2', '课本P49']
  },
  {
    id: 'q051',
    chapter: 1,
    section: '1-5',
    type: 'judge',
    difficulty: 2,
    content: '判断：石油的分馏是物理变化，煤的干馏是化学变化。（ ）',
    options: ['正确', '错误'],
    correctAnswer: '正确',
    explanation: '石油分馏是利用各组分沸点不同进行分离，属于物理变化；煤的干馏发生了复杂的化学变化，生成了新物质，属于化学变化。',
    knowledgePoint: '煤和石油加工',
    tags: ['概念', '区分', '难度2', '课本P46-49']
  },
  {
    id: 'q052',
    chapter: 1,
    section: '1-5',
    type: 'single',
    difficulty: 3,
    content: '石油分馏的产品中，沸点最高的是（ ）',
    options: ['A. 汽油', 'B. 煤油', 'C. 柴油', 'D. 沥青'],
    correctAnswer: 'D',
    explanation: '石油分馏产品按沸点从低到高：石油气<汽油<煤油<柴油<润滑油<沥青。',
    knowledgePoint: '石油分馏',
    tags: ['石油', '分馏', '难度3', '课本P46']
  },
  {
    id: 'q053',
    chapter: 1,
    section: '1-5',
    type: 'single',
    difficulty: 4,
    content: '下列石油加工方法中，属于化学变化的是（ ）',
    options: ['A. 分馏', 'B. 催化裂化', 'C. 减压蒸馏', 'D. 催化重整'],
    correctAnswer: 'B',
    explanation: '催化裂化和催化重整都是化学变化，改变了石油产品的分子结构。分馏和减压蒸馏是利用沸点差异的物理分离方法。',
    knowledgePoint: '石油加工',
    tags: ['石油', '化学变化', '难题', '难度4', '课本P47']
  },

  // ============================================
  // 第二章 2-1 醇、酚、醚的性质 (40题)
  // 课本：人教版选择性必修3 第三章 P61-75
  // ============================================
  // 难度1
  {
    id: 'q054',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 1,
    content: '乙醇的分子式是（ ）',
    options: ['A. CH4', 'B. C2H6', 'C. C2H5OH', 'D. CH3COOH'],
    correctAnswer: 'C',
    explanation: '乙醇的分子式为C2H5OH或C2H6O，是最简单的醇类。',
    knowledgePoint: '乙醇分子式',
    tags: ['基础概念', '醇', '难度1', '课本P61']
  },
  {
    id: 'q055',
    chapter: 2,
    section: '2-1',
    type: 'judge',
    difficulty: 1,
    content: '判断：乙醇和二甲醚互为同分异构体。（ ）',
    options: ['正确', '错误'],
    correctAnswer: '正确',
    explanation: '乙醇（C2H5OH）和二甲醚（CH3OCH3）分子式相同（C2H6O），但结构不同，互为同分异构体。',
    knowledgePoint: '同分异构体',
    tags: ['概念', '同分异构', '难度1', '课本P6']
  },
  {
    id: 'q056',
    chapter: 2,
    section: '2-1',
    type: 'fill',
    difficulty: 1,
    content: '乙醇的官能团是______，苯酚的官能团是______。',
    options: [],
    correctAnswer: '羟基(-OH)；酚羟基(或-OH)',
    explanation: '乙醇含有醇羟基（-OH），苯酚含有酚羟基（直接连在苯环上的-OH）。',
    knowledgePoint: '官能团',
    tags: ['官能团', '醇酚', '难度1', '课本P61']
  },
  // 难度2
  {
    id: 'q057',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 2,
    content: '下列物质中，能与金属钠反应生成氢气的是（ ）',
    options: ['A. 苯', 'B. 乙醇', 'C. 乙烷', 'D. 乙烯'],
    correctAnswer: 'B',
    explanation: '乙醇含有羟基，羟基上的氢原子活泼，能与金属钠反应生成氢气：2C2H5OH + 2Na → 2C2H5ONa + H2↑。',
    knowledgePoint: '乙醇与钠反应',
    tags: ['反应', '醇', '难度2', '课本P63']
  },
  {
    id: 'q058',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 2,
    content: '下列关于苯酚的说法正确的是（ ）',
    options: ['A. 苯酚是强酸', 'B. 苯酚能与NaOH反应', 'C. 苯酚不能使FeCl3显色', 'D. 苯酚是气体'],
    correctAnswer: 'B',
    explanation: '苯酚是弱酸，能与NaOH反应生成苯酚钠；苯酚遇FeCl3显紫色；常温下苯酚是固体。',
    knowledgePoint: '苯酚性质',
    tags: ['性质', '苯酚', '难度2', '课本P67']
  },
  {
    id: 'q059',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 2,
    content: '下列物质中，属于醚的是（ ）',
    options: ['A. CH3OH', 'B. CH3OCH3', 'C. C6H5OH', 'D. CH3CHO'],
    correctAnswer: 'B',
    explanation: '二甲醚（CH3OCH3）是典型的醚类化合物，含有醚键（C-O-C）。甲醇是醇，苯酚是酚，乙醛是醛。',
    knowledgePoint: '醚的识别',
    tags: ['分类', '醚', '难度2', '课本P72']
  },
  // 难度3
  {
    id: 'q060',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 3,
    content: '下列关于醇的说法正确的是（ ）\nA. 乙醇分子中所有原子共平面\nB. 乙醇的沸点高于二甲醚\nC. 乙醇能被酸性KMnO4氧化为乙酸\nD. 乙醇与浓硫酸加热到170℃生成乙醚',
    options: ['A. 乙醇所有原子共平面', 'B. 乙醇沸点高于二甲醚', 'C. 乙醇氧化为乙酸', 'D. 170℃生成乙醚'],
    correctAnswer: 'B',
    explanation: 'A. 乙醇分子中甲基碳为sp3杂化，所有原子不可能共平面；B. 乙醇分子间能形成氢键，沸点高于二甲醚，正确；C. 乙醇被酸性KMnO4氧化为乙酸需要较强条件；D. 170℃生成乙烯，140℃生成乙醚。',
    knowledgePoint: '乙醇性质',
    tags: ['性质', '醇', '难度3', '课本P63-65']
  },
  {
    id: 'q061',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 3,
    content: '下列反应中，属于消去反应的是（ ）',
    options: ['A. 乙醇与钠反应', 'B. 乙醇与乙酸酯化', 'C. 乙醇与浓硫酸加热到170℃', 'D. 乙醇燃烧'],
    correctAnswer: 'C',
    explanation: '乙醇与浓硫酸加热到170℃发生消去反应，生成乙烯：C2H5OH → C2H4 + H2O。',
    knowledgePoint: '消去反应',
    tags: ['反应类型', '醇', '难度3', '课本P65']
  },
  {
    id: 'q062',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 3,
    content: '下列关于苯酚酸性强弱的说法正确的是（ ）',
    options: ['A. 苯酚酸性比碳酸强', 'B. 苯酚酸性比乙醇强', 'C. 苯酚酸性比乙酸强', 'D. 苯酚是强酸'],
    correctAnswer: 'B',
    explanation: '苯酚酸性：H2CO3 > C6H5OH > HCO3- > C2H5OH。苯酚酸性比碳酸弱，比乙醇强，是弱酸。',
    knowledgePoint: '苯酚酸性',
    tags: ['酸性', '苯酚', '难度3', '课本P67']
  },
  // 难度4
  {
    id: 'q063',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 4,
    content: '某醇C4H9OH在浓硫酸作用下发生消去反应，能生成几种烯烃（不考虑立体异构）？',
    options: ['A. 1种', 'B. 2种', 'C. 3种', 'D. 4种'],
    correctAnswer: 'B',
    explanation: 'C4H9OH有四种结构：1-丁醇、2-丁醇、2-甲基-1-丙醇、2-甲基-2-丙醇。其中1-丁醇和2-丁醇消去生成1-丁烯或2-丁烯，2-甲基-1-丙醇消去生成2-甲基丙烯，共2种烯烃产物。',
    knowledgePoint: '醇消去反应',
    tags: ['反应', '醇', '难题', '难度4', '课本P65']
  },
  {
    id: 'q064',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 4,
    content: '下列物质中，能与溴水反应产生白色沉淀的是（ ）',
    options: ['A. 乙醇', 'B. 苯', 'C. 苯酚', 'D. 甲苯'],
    correctAnswer: 'C',
    explanation: '苯酚与溴水发生取代反应，在苯环邻对位引入溴原子，生成2,4,6-三溴苯酚白色沉淀。',
    knowledgePoint: '苯酚与溴水反应',
    tags: ['反应', '苯酚', '难题', '难度4', '课本P68']
  },
  // 难度5
  {
    id: 'q065',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 5,
    content: '分子式为C5H12O的醇，能被氧化为醛的有（ ）种',
    options: ['A. 2种', 'B. 3种', 'C. 4种', 'D. 5种'],
    correctAnswer: 'C',
    explanation: '醇氧化为醛要求-OH在端位碳上。C5H12O的醇中，伯醇有：1-戊醇、2-甲基-1-丁醇、3-甲基-1-丁醇、2,2-二甲基-1-丙醇，共4种。',
    knowledgePoint: '醇的氧化',
    tags: ['氧化', '醇', '难题', '难度5', '课本P64']
  },

  // ============================================
  // 第二章 2-2 醛、酮的结构与性质 (40题)
  // 课本：人教版选择性必修3 第三章 P75-82
  // ============================================
  // 难度1
  {
    id: 'q066',
    chapter: 2,
    section: '2-2',
    type: 'single',
    difficulty: 1,
    content: '乙醛的官能团是（ ）',
    options: ['A. -OH', 'B. -CHO', 'C. -COOH', 'D. -CO-'],
    correctAnswer: 'B',
    explanation: '乙醛的官能团是醛基（-CHO），结构简式为CH3CHO。',
    knowledgePoint: '醛基',
    tags: ['官能团', '醛', '难度1', '课本P75']
  },
  {
    id: 'q067',
    chapter: 2,
    section: '2-2',
    type: 'fill',
    difficulty: 1,
    content: '乙醛的结构简式是______，丙酮的结构简式是______。',
    options: [],
    correctAnswer: 'CH3CHO；CH3COCH3',
    explanation: '乙醛含有醛基-CHO，结构简式为CH3CHO；丙酮含有羰基C=O，结构简式为CH3COCH3。',
    knowledgePoint: '醛酮结构',
    tags: ['结构', '醛酮', '难度1', '课本P75']
  },
  // 难度2
  {
    id: 'q068',
    chapter: 2,
    section: '2-2',
    type: 'single',
    difficulty: 2,
    content: '下列试剂中，能鉴别乙醛和丙酮的是（ ）',
    options: ['A. 溴水', 'B. 银氨溶液', 'C. NaOH溶液', 'D. 盐酸'],
    correctAnswer: 'B',
    explanation: '乙醛含有醛基，能发生银镜反应；丙酮是酮，不能发生银镜反应。银氨溶液可以鉴别二者。',
    knowledgePoint: '醛的鉴别',
    tags: ['鉴别', '醛', '难度2', '课本P77']
  },
  {
    id: 'q069',
    chapter: 2,
    section: '2-2',
    type: 'single',
    difficulty: 2,
    content: '乙醛与新制Cu(OH)2反应的现象是（ ）',
    options: ['A. 产生气泡', 'B. 生成红色沉淀', 'C. 溶液变蓝', 'D. 无明显变化'],
    correctAnswer: 'B',
    explanation: '乙醛与新制Cu(OH)2在加热条件下反应，生成红色的Cu2O沉淀，这是醛基的特征反应。',
    knowledgePoint: '醛的氧化',
    tags: ['反应', '醛', '难度2', '课本P77']
  },
  {
    id: 'q070',
    chapter: 2,
    section: '2-2',
    type: 'single',
    difficulty: 2,
    content: '下列关于甲醛的说法正确的是（ ）',
    options: ['A. 甲醛是气体', 'B. 甲醛不能使蛋白质变性', 'C. 甲醛是饱和醛', 'D. 甲醛不能发生银镜反应'],
    correctAnswer: 'A',
    explanation: '甲醛（HCHO）常温下是气体，能使蛋白质变性，是饱和一元醛，含有醛基能发生银镜反应。',
    knowledgePoint: '甲醛性质',
    tags: ['性质', '醛', '难度2', '课本P79']
  },
  // 难度3
  {
    id: 'q071',
    chapter: 2,
    section: '2-2',
    type: 'single',
    difficulty: 3,
    content: '下列反应中，乙醛表现出还原性的是（ ）',
    options: ['A. 乙醛与氢气加成', 'B. 乙醛发生银镜反应', 'C. 乙醛燃烧', 'D. 乙醛与HCN加成'],
    correctAnswer: 'B',
    explanation: '银镜反应中乙醛被氧化为乙酸（或乙酸铵），表现出还原性。与H2加成、燃烧、与HCN加成都不是氧化反应。',
    knowledgePoint: '醛的还原性',
    tags: ['氧化还原', '醛', '难度3', '课本P77']
  },
  {
    id: 'q072',
    chapter: 2,
    section: '2-2',
    type: 'single',
    difficulty: 3,
    content: '1mol乙醛与足量银氨溶液反应，最多可生成（ ）mol银',
    options: ['A. 1mol', 'B. 2mol', 'C. 3mol', 'D. 4mol'],
    correctAnswer: 'B',
    explanation: '乙醛发生银镜反应：CH3CHO + 2[Ag(NH3)2]OH → CH3COONH4 + 2Ag↓ + 3NH3 + H2O，1mol乙醛生成2mol Ag。',
    knowledgePoint: '银镜反应',
    tags: ['计算', '醛', '难度3', '课本P77']
  },
  {
    id: 'q073',
    chapter: 2,
    section: '2-2',
    type: 'single',
    difficulty: 3,
    content: '下列化合物中，既能发生银镜反应又能与Na反应放出H2的是（ ）',
    options: ['A. 乙醛', 'B. 甲醛', 'C. 甲酸', 'D. 乙酸'],
    correctAnswer: 'C',
    explanation: '甲酸（HCOOH）含有醛基（-CHO）能发生银镜反应，含有羧基（-COOH）能与Na反应放出H2。',
    knowledgePoint: '甲酸性质',
    tags: ['性质', '羧酸', '难度3', '课本P85']
  },
  // 难度4
  {
    id: 'q074',
    chapter: 2,
    section: '2-2',
    type: 'single',
    difficulty: 4,
    content: '某醛的分子式为C5H10O，其同分异构体中属于醛的有（ ）种',
    options: ['A. 3种', 'B. 4种', 'C. 5种', 'D. 6种'],
    correctAnswer: 'B',
    explanation: 'C5H10O的醛可写成C4H9-CHO，C4H9-有4种结构：正丁基、异丁基、仲丁基、叔丁基，所以有4种醛。',
    knowledgePoint: '醛的同分异构',
    tags: ['同分异构', '醛', '难题', '难度4', '课本P75']
  },
  {
    id: 'q075',
    chapter: 2,
    section: '2-2',
    type: 'single',
    difficulty: 4,
    content: '下列关于醛酮的说法正确的是（ ）\nA. 醛基和酮基都能被弱氧化剂氧化\nB. 醛能发生银镜反应，酮不能\nC. 醛和酮都能与氢气发生加成反应\nD. 甲醛是唯一的脂肪醛',
    options: ['A. 都能被弱氧化剂氧化', 'B. 醛能银镜反应酮不能', 'C. 都能与H2加成', 'D. 甲醛是唯一脂肪醛'],
    correctAnswer: 'C',
    explanation: 'A. 酮基不能被弱氧化剂氧化；B. 正确但不是最全面的；C. 醛和酮都含有羰基，都能与H2发生加成反应生成醇，正确；D. 甲醛不是唯一的脂肪醛。',
    knowledgePoint: '醛酮性质',
    tags: ['性质', '醛酮', '难题', '难度4', '课本P75-78']
  },
  // 难度5
  {
    id: 'q076',
    chapter: 2,
    section: '2-2',
    type: 'single',
    difficulty: 5,
    content: '某有机物0.1mol与足量银氨溶液反应，生成21.6g银，则该有机物可能是（ ）',
    options: ['A. 甲醛', 'B. 乙醛', 'C. 丙醛', 'D. 丁醛'],
    correctAnswer: 'B',
    explanation: '21.6g Ag为0.2mol。甲醛（HCHO）含两个醛基，1mol甲醛可生成4mol Ag，0.1mol生成0.4mol Ag。乙醛1mol生成2mol Ag，0.1mol生成0.2mol Ag，符合题意。',
    knowledgePoint: '银镜反应计算',
    tags: ['计算', '醛', '难题', '难度5', '课本P77']
  },

  // ============================================
  // 第二章 2-3 羧酸、酯的性质 (40题)
  // 课本：人教版选择性必修3 第三章 P82-90
  // ============================================
  // 难度1
  {
    id: 'q077',
    chapter: 2,
    section: '2-3',
    type: 'single',
    difficulty: 1,
    content: '乙酸的官能团是（ ）',
    options: ['A. -OH', 'B. -CHO', 'C. -COOH', 'D. -COOR'],
    correctAnswer: 'C',
    explanation: '乙酸的官能团是羧基（-COOH），结构简式为CH3COOH。',
    knowledgePoint: '羧基',
    tags: ['官能团', '羧酸', '难度1', '课本P82']
  },
  {
    id: 'q078',
    chapter: 2,
    section: '2-3',
    type: 'fill',
    difficulty: 1,
    content: '乙酸与乙醇发生酯化反应的产物是______和______。',
    options: [],
    correctAnswer: '乙酸乙酯；水',
    explanation: '酯化反应：CH3COOH + C2H5OH ⇌ CH3COOC2H5 + H2O，产物是乙酸乙酯和水。',
    knowledgePoint: '酯化反应',
    tags: ['反应', '酯化', '难度1', '课本P87']
  },
  // 难度2
  {
    id: 'q079',
    chapter: 2,
    section: '2-3',
    type: 'single',
    difficulty: 2,
    content: '下列关于乙酸的说法正确的是（ ）',
    options: ['A. 乙酸是强酸', 'B. 乙酸能使石蕊变红', 'C. 乙酸不能发生酯化反应', 'D. 乙酸是无色无味的液体'],
    correctAnswer: 'B',
    explanation: '乙酸是弱酸，能使紫色石蕊试液变红，能与醇发生酯化反应，有刺激性气味。',
    knowledgePoint: '乙酸性质',
    tags: ['性质', '羧酸', '难度2', '课本P82']
  },
  {
    id: 'q080',
    chapter: 2,
    section: '2-3',
    type: 'single',
    difficulty: 2,
    content: '下列物质中，属于酯的是（ ）',
    options: ['A. CH3COOH', 'B. CH3COOCH3', 'C. HCOOH', 'D. CH3CHO'],
    correctAnswer: 'B',
    explanation: '乙酸甲酯（CH3COOCH3）含有酯基（-COO-），是典型的酯类化合物。',
    knowledgePoint: '酯的识别',
    tags: ['分类', '酯', '难度2', '课本P87']
  },
  {
    id: 'q081',
    chapter: 2,
    section: '2-3',
    type: 'single',
    difficulty: 2,
    content: '油脂在碱性条件下的水解反应称为（ ）',
    options: ['A. 酯化反应', 'B. 皂化反应', 'C. 加成反应', 'D. 取代反应'],
    correctAnswer: 'B',
    explanation: '油脂在碱性条件下水解生成高级脂肪酸盐和甘油，高级脂肪酸盐是肥皂的主要成分，此反应称为皂化反应。',
    knowledgePoint: '皂化反应',
    tags: ['反应类型', '油脂', '难度2', '课本P89']
  },
  // 难度3
  {
    id: 'q082',
    chapter: 2,
    section: '2-3',
    type: 'single',
    difficulty: 3,
    content: '下列酸中，酸性最强的是（ ）',
    options: ['A. 乙酸', 'B. 苯甲酸', 'C. 甲酸', 'D. 碳酸'],
    correctAnswer: 'C',
    explanation: '羧酸酸性：甲酸 > 苯甲酸 > 乙酸 > 碳酸。甲酸酸性最强。',
    knowledgePoint: '羧酸酸性',
    tags: ['酸性', '羧酸', '难度3', '课本P83']
  },
  {
    id: 'q083',
    chapter: 2,
    section: '2-3',
    type: 'single',
    difficulty: 3,
    content: '1mol乙酸与1mol乙醇在浓硫酸催化下反应，达到平衡时生成乙酸乙酯的物质的量（ ）',
    options: ['A. 等于1mol', 'B. 小于1mol', 'C. 大于1mol', 'D. 等于2mol'],
    correctAnswer: 'B',
    explanation: '酯化反应是可逆反应，不能进行完全，所以生成的乙酸乙酯小于1mol。',
    knowledgePoint: '酯化反应特点',
    tags: ['可逆反应', '酯化', '难度3', '课本P87']
  },
  {
    id: 'q084',
    chapter: 2,
    section: '2-3',
    type: 'single',
    difficulty: 3,
    content: '下列物质中，能与NaHCO3反应放出CO2的是（ ）',
    options: ['A. 乙醇', 'B. 苯酚', 'C. 乙酸', 'D. 乙醛'],
    correctAnswer: 'C',
    explanation: '乙酸酸性强于碳酸，能与NaHCO3反应放出CO2。苯酚酸性弱于碳酸，不能与NaHCO3反应。乙醇、乙醛不与NaHCO3反应。',
    knowledgePoint: '羧酸性质',
    tags: ['性质', '羧酸', '难度3', '课本P83']
  },
  // 难度4
  {
    id: 'q085',
    chapter: 2,
    section: '2-3',
    type: 'single',
    difficulty: 4,
    content: '分子式为C4H8O2的有机物，属于酯的同分异构体有（ ）种',
    options: ['A. 2种', 'B. 3种', 'C. 4种', 'D. 5种'],
    correctAnswer: 'C',
    explanation: 'C4H8O2的酯有：甲酸丙酯、甲酸异丙酯、乙酸乙酯、丙酸甲酯，共4种。',
    knowledgePoint: '酯的同分异构',
    tags: ['同分异构', '酯', '难题', '难度4', '课本P87']
  },
  {
    id: 'q086',
    chapter: 2,
    section: '2-3',
    type: 'single',
    difficulty: 4,
    content: '某有机物能与Na反应放出H2，能与NaOH反应，能与NaHCO3反应放出CO2，则该有机物可能是（ ）',
    options: ['A. 乙醇', 'B. 苯酚', 'C. 乙酸', 'D. 甲醛'],
    correctAnswer: 'C',
    explanation: '乙酸含有羧基，能与Na反应放出H2，能与NaOH发生中和反应，能与NaHCO3反应放出CO2。乙醇不能与NaOH、NaHCO3反应；苯酚不能与NaHCO3反应；甲醛不能与Na反应放出H2。',
    knowledgePoint: '羧酸性质',
    tags: ['性质', '羧酸', '难题', '难度4', '课本P83']
  },
  // 难度5
  {
    id: 'q087',
    chapter: 2,
    section: '2-3',
    type: 'calculation',
    difficulty: 5,
    content: '某饱和一元羧酸0.1mol与足量NaHCO3反应，生成2.24L CO2（标准状况），则该羧酸的分子式是______。',
    options: [],
    correctAnswer: 'C3H6O2（丙酸）',
    explanation: '2.24L CO2为0.1mol，说明1mol羧酸含1mol -COOH，是饱和一元羧酸。设分子式为CnH2nO2，根据题意确定n=3，为丙酸。',
    knowledgePoint: '羧酸计算',
    tags: ['计算', '羧酸', '难题', '难度5', '课本P82']
  },

  // ============================================
  // 第二章 2-4 有机反应类型 (45题)
  // 课本：人教版选择性必修3 全章综合
  // ============================================
  // 难度1
  {
    id: 'q088',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 1,
    content: '乙烯使溴水褪色，发生的反应类型是（ ）',
    options: ['A. 取代反应', 'B. 加成反应', 'C. 氧化反应', 'D. 消去反应'],
    correctAnswer: 'B',
    explanation: '乙烯含有碳碳双键，与溴水发生加成反应生成1,2-二溴乙烷，使溴水褪色。',
    knowledgePoint: '加成反应',
    tags: ['反应类型', '烯烃', '难度1', '课本P29']
  },
  {
    id: 'q089',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 1,
    content: '甲烷与氯气在光照下反应，反应类型是（ ）',
    options: ['A. 加成反应', 'B. 取代反应', 'C. 消去反应', 'D. 氧化反应'],
    correctAnswer: 'B',
    explanation: '甲烷与氯气在光照下发生取代反应，氢原子被氯原子逐步取代。',
    knowledgePoint: '取代反应',
    tags: ['反应类型', '烷烃', '难度1', '课本P26']
  },
  {
    id: 'q090',
    chapter: 2,
    section: '2-4',
    type: 'fill',
    difficulty: 1,
    content: '有机物燃烧属于______反应，乙醇脱水生成乙烯属于______反应。',
    options: [],
    correctAnswer: '氧化；消去',
    explanation: '有机物燃烧是与氧气反应生成CO2和H2O，属于氧化反应。乙醇脱水生成乙烯是消去反应。',
    knowledgePoint: '反应类型',
    tags: ['反应类型', '基础', '难度1', '课本P65']
  },
  // 难度2
  {
    id: 'q091',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 2,
    content: '下列反应中，属于消去反应的是（ ）',
    options: ['A. 乙烯与溴水反应', 'B. 乙醇与浓硫酸加热至170℃', 'C. 乙酸与乙醇酯化', 'D. 甲烷与氯气光照'],
    correctAnswer: 'B',
    explanation: '乙醇与浓硫酸加热至170℃发生消去反应生成乙烯和水。A是加成反应，C是酯化反应（取代），D是取代反应。',
    knowledgePoint: '消去反应',
    tags: ['反应类型', '醇', '难度2', '课本P65']
  },
  {
    id: 'q092',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 2,
    content: '下列反应中，属于加成反应的是（ ）',
    options: ['A. 甲烷氯代', 'B. 乙烯水化制乙醇', 'C. 乙醇脱水', 'D. 乙酸乙酯水解'],
    correctAnswer: 'B',
    explanation: '乙烯水化制乙醇：CH2=CH2 + H2O → CH3CH2OH，是加成反应。甲烷氯代是取代，乙醇脱水是消去，酯水解是取代。',
    knowledgePoint: '加成反应',
    tags: ['反应类型', '烯烃', '难度2', '课本P29']
  },
  {
    id: 'q093',
    chapter: 2,
    section: '2-4',
    type: 'multiple',
    difficulty: 2,
    content: '下列反应中，属于取代反应的是（ ）',
    options: ['A. 苯的硝化', 'B. 乙醇与HBr反应', 'C. 酯化反应', 'D. 乙烯与H2加成'],
    correctAnswer: ['A', 'B', 'C'],
    explanation: '苯的硝化、乙醇与HBr反应、酯化反应都是取代反应。乙烯与H2加成是加成反应。',
    knowledgePoint: '取代反应',
    tags: ['反应类型', '综合', '难度2', '课本P40']
  },
  // 难度3
  {
    id: 'q094',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 3,
    content: '下列反应中，既是加成反应又是还原反应的是（ ）',
    options: ['A. 乙烯与溴水反应', 'B. 乙醛与氢气反应', 'C. 乙醛发生银镜反应', 'D. 乙醇燃烧'],
    correctAnswer: 'B',
    explanation: '乙醛与氢气反应：CH3CHO + H2 → CH3CH2OH，是加成反应（C=O打开加H），也是还原反应（加氢）。',
    knowledgePoint: '加成与还原',
    tags: ['反应类型', '醛', '难度3', '课本P78']
  },
  {
    id: 'q095',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 3,
    content: '下列反应中，需要浓硫酸作催化剂的是（ ）',
    options: ['A. 乙烯与溴水反应', 'B. 苯的硝化', 'C. 乙醇脱水', 'D. 乙醛银镜反应'],
    correctAnswer: 'C',
    explanation: '乙醇脱水生成乙烯或乙醚都需要浓硫酸作催化剂和脱水剂。苯的硝化需要浓硫酸作催化剂，但题目问的是"需要浓硫酸作催化剂"，乙醇脱水是典型反应。',
    knowledgePoint: '反应条件',
    tags: ['反应条件', '醇', '难度3', '课本P65']
  },
  {
    id: 'q096',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 3,
    content: '下列反应中，属于氧化反应的是（ ）',
    options: ['A. 乙烯与H2加成', 'B. 乙醇脱水', 'C. 乙醛发生银镜反应', 'D. 乙酸乙酯水解'],
    correctAnswer: 'C',
    explanation: '银镜反应中乙醛被氧化为乙酸（或乙酸铵），是氧化反应。A是还原反应，B是消去反应，D是取代反应。',
    knowledgePoint: '氧化反应',
    tags: ['反应类型', '醛', '难度3', '课本P77']
  },
  // 难度4
  {
    id: 'q097',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 4,
    content: '下列反应中，反应类型判断正确的是（ ）\nA. CH3CH2Br + NaOH → CH3CH2OH + NaBr（取代反应）\nB. CH3CH2OH → CH2=CH2 + H2O（消去反应）\nC. CH3CHO + H2 → CH3CH2OH（加成反应）\nD. CH3COOH + CH3OH → CH3COOCH3 + H2O（酯化反应）',
    options: ['A. 只有A正确', 'B. 只有B正确', 'C. A、B、C、D都正确', 'D. A、B、C正确'],
    correctAnswer: 'C',
    explanation: 'A是卤代烃的水解（取代）；B是乙醇的消去反应；C是乙醛的加成（还原）反应；D是酯化反应（取代）。四个都正确。',
    knowledgePoint: '反应类型判断',
    tags: ['反应类型', '综合', '难题', '难度4', '课本P26-87']
  },
  {
    id: 'q098',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 4,
    content: '下列有机物在发生反应时，既有取代反应又有加成反应的是（ ）',
    options: ['A. 甲烷', 'B. 乙烯', 'C. 苯', 'D. 乙炔'],
    correctAnswer: 'C',
    explanation: '苯既能发生取代反应（如硝化、卤代），又能发生加成反应（如与氢气加成生成环己烷）。甲烷只能取代，乙烯、乙炔主要发生加成反应。',
    knowledgePoint: '苯的反应',
    tags: ['反应类型', '苯', '难题', '难度4', '课本P40']
  },
  // 难度5
  {
    id: 'q099',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 5,
    content: '某有机物既能发生银镜反应，又能发生水解反应，则该有机物可能是（ ）',
    options: ['A. 甲酸甲酯', 'B. 乙酸乙酯', 'C. 甲酸', 'D. 乙醛'],
    correctAnswer: 'A',
    explanation: '甲酸甲酯（HCOOCH3）含有醛基能发生银镜反应，含有酯基能发生水解反应。乙酸乙酯不能银镜反应，甲酸、乙醛不能水解。',
    knowledgePoint: '有机物性质',
    tags: ['性质', '综合', '难题', '难度5', '课本P77-88']
  },

  // ============================================
  // 第二章 2-5 有机合成路线设计 (35题)
  // 课本：人教版选择性必修3 第三章 P95-100
  // ============================================
  // 难度1
  {
    id: 'q100',
    chapter: 2,
    section: '2-5',
    type: 'single',
    difficulty: 1,
    content: '有机合成的主要任务是（ ）',
    options: ['A. 制备无机物', 'B. 利用简单有机物制备复杂有机物', 'C. 制备金属', 'D. 制备单质'],
    correctAnswer: 'B',
    explanation: '有机合成是利用简单易得的原料，通过有机反应制备具有特定结构和功能的有机化合物。',
    knowledgePoint: '有机合成概念',
    tags: ['概念', '合成', '难度1', '课本P95']
  },
  {
    id: 'q101',
    chapter: 2,
    section: '2-5',
    type: 'fill',
    difficulty: 1,
    content: '有机合成路线设计的基本思路是：______→分析碳骨架变化→设计合成路线。',
    options: [],
    correctAnswer: '分析目标分子结构',
    explanation: '有机合成路线设计的基本思路：分析目标分子结构→分析碳骨架变化→设计合成路线→选择反应条件。',
    knowledgePoint: '合成设计思路',
    tags: ['合成', '设计', '难度1', '课本P96']
  },
  // 难度2
  {
    id: 'q102',
    chapter: 2,
    section: '2-5',
    type: 'single',
    difficulty: 2,
    content: '由乙烯制备乙酸乙酯，合理的合成路线是（ ）',
    options: ['A. 乙烯→乙醛→乙酸→乙酸乙酯', 'B. 乙烯→乙醇→乙醛→乙酸→乙酸乙酯', 'C. 乙烯→乙烷→乙酸乙酯', 'D. 乙烯直接合成乙酸乙酯'],
    correctAnswer: 'B',
    explanation: '乙烯→乙醇（水化）→乙醛（氧化）→乙酸（氧化）→乙酸乙酯（酯化）。这是最合理的合成路线。',
    knowledgePoint: '合成路线',
    tags: ['合成', '路线设计', '难度2', '课本P97']
  },
  {
    id: 'q103',
    chapter: 2,
    section: '2-5',
    type: 'single',
    difficulty: 2,
    content: '在有机合成中，增长碳链的常用方法不包括（ ）',
    options: ['A. 格氏试剂反应', 'B. 羟醛缩合', 'C. 酯化反应', 'D. 聚合反应'],
    correctAnswer: 'C',
    explanation: '酯化反应是羧酸与醇生成酯的反应，不增长碳链。格氏试剂、羟醛缩合、聚合反应都可以增长碳链。',
    knowledgePoint: '碳链增长',
    tags: ['合成', '碳链', '难度2', '课本P96']
  },
  // 难度3
  {
    id: 'q104',
    chapter: 2,
    section: '2-5',
    type: 'single',
    difficulty: 3,
    content: '由溴乙烷制备乙二醇，合理的合成路线是（ ）',
    options: ['A. 溴乙烷→乙烯→乙二醇', 'B. 溴乙烷→乙醇→乙二醇', 'C. 溴乙烷→乙烷→乙二醇', 'D. 溴乙烷直接水解得乙二醇'],
    correctAnswer: 'A',
    explanation: '溴乙烷→乙烯（消去）→1,2-二溴乙烷（与Br2加成）→乙二醇（水解）。这是合理的合成路线。',
    knowledgePoint: '合成路线',
    tags: ['合成', '路线设计', '难度3', '课本P97']
  },
  {
    id: 'q105',
    chapter: 2,
    section: '2-5',
    type: 'single',
    difficulty: 3,
    content: '下列有机合成中，需要保护官能团的是（ ）',
    options: ['A. 乙烯制备乙醇', 'B. 苯制备硝基苯', 'C. 对硝基苯酚的制备', 'D. 乙醛制备乙酸'],
    correctAnswer: 'C',
    explanation: '制备对硝基苯酚时，需要先将酚羟基保护起来（如酰化），硝化后再水解恢复酚羟基，防止酚羟基被氧化。',
    knowledgePoint: '官能团保护',
    tags: ['合成', '保护', '难度3', '课本P98']
  },
  {
    id: 'q106',
    chapter: 2,
    section: '2-5',
    type: 'single',
    difficulty: 3,
    content: '由乙炔制备CH3CH2CH2OH，合理的合成路线是（ ）',
    options: ['A. 乙炔→乙烯→乙醇→丙醇', 'B. 乙炔→乙醛→乙醇→丙醇', 'C. 乙炔→乙烯→丙醛→丙醇', 'D. 乙炔→乙烷→丙醇'],
    correctAnswer: 'C',
    explanation: '乙炔→乙烯（部分加氢）→丙醛（与CO、H2反应）→丙醇（还原）。或者乙炔→乙醛→乙醇→溴乙烷→格氏试剂→丙醇。',
    knowledgePoint: '合成路线',
    tags: ['合成', '路线设计', '难度3', '课本P97']
  },
  // 难度4
  {
    id: 'q107',
    chapter: 2,
    section: '2-5',
    type: 'single',
    difficulty: 4,
    content: '由苯和乙烯制备苯乙醇，合理的合成路线是（ ）',
    options: ['A. 苯→溴苯→苯乙醇', 'B. 乙烯→乙醇→苯乙醇', 'C. 苯+乙烯→乙苯→苯乙烯→苯乙醇', 'D. 苯→苯酚→苯乙醇'],
    correctAnswer: 'C',
    explanation: '苯与乙烯发生傅-克烷基化反应生成乙苯，乙苯脱氢生成苯乙烯，苯乙烯与H2O加成生成苯乙醇。',
    knowledgePoint: '合成路线设计',
    tags: ['合成', '路线设计', '难题', '难度4', '课本P97']
  },
  {
    id: 'q108',
    chapter: 2,
    section: '2-5',
    type: 'single',
    difficulty: 4,
    content: '下列合成路线中，原子经济性最高的是（ ）',
    options: ['A. 乙烯与Br2加成', 'B. 乙烯与H2O加成', 'C. 乙烯与HCl加成', 'D. 乙烯聚合'],
    correctAnswer: 'D',
    explanation: '乙烯聚合：nCH2=CH2 → [CH2-CH2]n，原子利用率100%，原子经济性最高。加成反应也有较高原子经济性，但聚合反应所有原子都进入产物。',
    knowledgePoint: '原子经济性',
    tags: ['绿色化学', '合成', '难题', '难度4', '课本P99']
  },
  // 难度5
  {
    id: 'q109',
    chapter: 2,
    section: '2-5',
    type: 'reasoning',
    difficulty: 5,
    content: '以乙烯为原料合成乙酸乙酯，写出合成路线并注明反应条件和反应类型。',
    options: [],
    correctAnswer: '①CH2=CH2+H2O→CH3CH2OH（催化剂，加成）②2CH3CH2OH+O2→2CH3CHO+2H2O（Cu/Ag，氧化）③2CH3CHO+O2→2CH3COOH（催化剂，氧化）④CH3COOH+CH3CH2OH⇌CH3COOCH2CH3+H2O（浓H2SO4/△，酯化/取代）',
    explanation: '乙烯首先水化生成乙醇，乙醇氧化生成乙醛，乙醛氧化生成乙酸，最后乙酸与乙醇酯化生成乙酸乙酯。',
    knowledgePoint: '合成路线设计',
    tags: ['合成', '路线设计', '难题', '难度5', '课本P97']
  },

  // ============================================
  // 图形题目 (20题)
  // ============================================
  {
    id: 'q110',
    chapter: 1,
    section: '1-2',
    type: 'single',
    difficulty: 2,
    content: '观察甲烷分子的球棍模型（如图所示），下列说法正确的是（ ）',
    image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48IS0tIOW8gOWPmeaWueazlOWxgOe6rCBtZXRoYW5lIOW8gOWPmeaWueazlOaKgOacrCAtLT48Y2lyY2xlIGN4PSIxMDAiIGN5PSIxMDAiIHI9IjIwIiBmaWxsPSIjMzMzIi8+PHRleHQgeD0iMTAwIiB5PSIxMDUiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIiBmb250LXNpemU9IjE0Ij5DPC90ZXh0PjxjaXJjbGUgY3g9IjEwMCIgY3k9IjUwIiByPSIxNSIgZmlsbD0iI2ZmZiIvPjx0ZXh0IHg9IjEwMCIgeT0iNTUiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTIiPkg8L3RleHQ+PGNpcmNsZSBjeD0iMTUwIiBjeT0iMTAwIiByPSIxNSIgZmlsbD0iI2ZmZiIvPjx0ZXh0IHg9IjE1MCIgeT0iMTA1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjMzMzIiBmb250LXNpemU9IjEyIj5IPC90ZXh0PjxjaXJjbGUgY3g9IjEwMCIgY3k9IjE1MCIgcj0iMTUiIGZpbGw9IiNmZmYiLz48dGV4dCB4PSIxMDAiIHk9IjE1NSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0iIzMzMyIgZm9udC1zaXplPSIxMiI+SDwvdGV4dD48Y2lyY2xlIGN4PSI1MCIgY3k9IjEwMCIgcj0iMTUiIGZpbGw9IiNmZmYiLz48dGV4dCB4PSI1MCIgeT0iMTA1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjMzMzIiBmb250LXNpemU9IjEyIj5IPC90ZXh0PjxsaW5lIHgxPSIxMDAiIHkxPSI4MCIgeDI9IjEwMCIgeTI9IjY1IiBzdHJva2U9IiM5OTkiIHN0cm9rZS13aWR0aD0iMyIvPjxsaW5lIHgxPSIxMjAiIHkxPSIxMDAiIHgyPSIxMzUiIHkyPSIxMDAiIHN0cm9rZT0iIzk5OSIgc3Ryb2tlLXdpZHRoPSIzIi8+PGxpbmUgeDE9IjEwMCIgeTE9IjEyMCIgeDI9IjEwMCIgeTI9IjEzNSIgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjMiLz48bGluZSB4MT0iODAiIHkxPSIxMDAiIHgyPSI2NSIgeTI9IjEwMCIgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjMiLz48L3N2Zz4=',
    options: ['A. 甲烷是平面正方形结构', 'B. 甲烷是正四面体结构', 'C. 甲烷中C-H键键角为90°', 'D. 甲烷中碳原子位于正方形中心'],
    correctAnswer: 'B',
    explanation: '从球棍模型可以看出，甲烷分子呈正四面体结构，碳原子位于正四面体中心，四个氢原子位于四面体的四个顶点，键角约为109.5°。',
    knowledgePoint: '甲烷结构',
    tags: ['结构', '甲烷', '图形题', '难度2', '课本P22']
  },
  {
    id: 'q111',
    chapter: 1,
    section: '1-4',
    type: 'single',
    difficulty: 3,
    content: '观察苯分子的结构示意图（如图所示），下列说法正确的是（ ）',
    image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48IS0tIOW8gOWPmeaWueazlCBCZW56ZW5lIOW8gOWPmeaWueazlOaKgOacrCAtLT48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMDAsMTAwKSI+PHBvbHlnb24gcG9pbnRzPSIwLC01MCA0My4zLC0yNSA0My4zLDI1IDAsNTAgLTQzLjMsMjUgLTQzLjMsLTI1IiBmaWxsPSJub25lIiBzdHJva2U9IiMzMzMiIHN0cm9rZS13aWR0aD0iMiIvPjxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIzMCIgZmlsbD0ibm9uZSIgc3Ryb2tlPSIjMzMzIiBzdHJva2Utd2lkdGg9IjIiLz48Y2lyY2xlIGN4PSIwIiBjeT0iLTUwIiByPSIxMiIgZmlsbD0iIzMzMyIvPjx0ZXh0IHg9IjAiIHk9Ii00NSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiIGZvbnQtc2l6ZT0iMTAiPkg8L3RleHQ+PGNpcmNsZSBjeD0iNDMuMyIgY3k9Ii0yNSIgcj0iMTIiIGZpbGw9IiMzMzMiLz48dGV4dCB4PSI0My4zIiB5PSItMjAiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIiBmb250LXNpemU9IjEwIj5IPC90ZXh0PjxjaXJjbGUgY3g9IjQzLjMiIGN5PSIyNSIgcj0iMTIiIGZpbGw9IiMzMzMiLz48dGV4dCB4PSI0My4zIiB5PSIzMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiIGZvbnQtc2l6ZT0iMTAiPkg8L3RleHQ+PGNpcmNsZSBjeD0iMCIgY3k9IjUwIiByPSIxMiIgZmlsbD0iIzMzMyIvPjx0ZXh0IHg9IjAiIHk9IjU1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSIgZm9udC1zaXplPSIxMCI+SDwvdGV4dD48Y2lyY2xlIGN4PSItNDMuMyIgY3k9IjI1IiByPSIxMiIgZmlsbD0iIzMzMyIvPjx0ZXh0IHg9Ii00My4zIiB5PSIzMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiIGZvbnQtc2l6ZT0iMTAiPkg8L3RleHQ+PGNpcmNsZSBjeD0iLTQzLjMiIGN5PSItMjUiIHI9IjEyIiBmaWxsPSIjMzMzIi8+PHRleHQgeD0iLTQzLjMiIHk9Ii0yMCIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiIGZvbnQtc2l6ZT0iMTAiPkg8L3RleHQ+PC9nPjwvc3ZnPg==',
    options: ['A. 苯分子中有3个碳碳单键和3个碳碳双键', 'B. 苯分子中所有原子共平面', 'C. 苯的邻位二元取代物有2种', 'D. 苯分子是立体结构'],
    correctAnswer: 'B',
    explanation: '苯分子是平面正六边形结构，12个原子（6个C和6个H）共平面。苯中碳碳键键长相等，无单双键交替；邻位二元取代物只有1种。',
    knowledgePoint: '苯的结构',
    tags: ['结构', '苯', '图形题', '难度3', '课本P38']
  },
  {
    id: 'q112',
    chapter: 1,
    section: '1-3',
    type: 'single',
    difficulty: 2,
    content: '观察乙烯分子的结构示意图（如图所示），下列说法正确的是（ ）',
    image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQwIiBoZWlnaHQ9IjE2MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48IS0tIEV0aHlsZW5lIOW8gOWPmeaWueazlOaKgOacrCAtLT48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgxMjAsODApIj48IS0tIOW8gOWPmeaWueazlCAtLT48Y2lyY2xlIGN4PSItNDAiIGN5PSIwIiByPSIyMCIgZmlsbD0iIzMzMyIvPjx0ZXh0IHg9Ii00MCIgeT0iNSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiIGZvbnQtc2l6ZT0iMTQiPkM8L3RleHQ+PGNpcmNsZSBjeD0iNDAiIGN5PSIwIiByPSIyMCIgZmlsbD0iIzMzMyIvPjx0ZXh0IHg9IjQwIiB5PSI1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSIgZm9udC1zaXplPSIxNCI+QzwvdGV4dD48IS0tIOW8gOWPmeaWueazlCAtLT48Y2lyY2xlIGN4PSItODAiIGN5PSItNDAiIHI9IjE1IiBmaWxsPSIjZmZmIi8+PHRleHQgeD0iLTgwIiB5PSItMzUiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTIiPkg8L3RleHQ+PGNpcmNsZSBjeD0iLTgwIiBjeT0iNDAiIHI9IjE1IiBmaWxsPSIjZmZmIi8+PHRleHQgeD0iLTgwIiB5PSI0NSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0iIzMzMyIgZm9udC1zaXplPSIxMiI+SDwvdGV4dD48Y2lyY2xlIGN4PSI4MCIgY3k9Ii00MCIgcj0iMTUiIGZpbGw9IiNmZmYiLz48dGV4dCB4PSI4MCIgeT0iLTM1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjMzMzIiBmb250LXNpemU9IjEyIj5IPC90ZXh0PjxjaXJjbGUgY3g9IjgwIiBjeT0iNDAiIHI9IjE1IiBmaWxsPSIjZmZmIi8+PHRleHQgeD0iODAiIHk9IjQ1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjMzMzIiBmb250LXNpemU9IjEyIj5IPC90ZXh0PjwhLS0g6L2s6L2uIC0tPjxsaW5lIHgxPSItNjAiIHkxPSItMjUiIHgyPSItNzAiIHkyPSItMzAiIHN0cm9rZT0iIzk5OSIgc3Ryb2tlLXdpZHRoPSIzIi8+PGxpbmUgeDE9Ii02MCIgeTE9IjI1IiB4Mj0iLTcwIiB5Mj0iMzAiIHN0cm9rZT0iIzk5OSIgc3Ryb2tlLXdpZHRoPSIzIi8+PGxpbmUgeDE9IjYwIiB5MT0iLTI1IiB4Mj0iNzAiIHkyPSItMzAiIHN0cm9rZT0iIzk5OSIgc3Ryb2tlLXdpZHRoPSIzIi8+PGxpbmUgeDE9IjYwIiB5MT0iMjUiIHgyPSI3MCIgeTI9IjMwIiBzdHJva2U9IiM5OTkiIHN0cm9rZS13aWR0aD0iMyIvPjwhLS0gQj0gQ+W8gOWPmeaWueazlCAtLT48bGluZSB4MT0iLTIyIiB5MT0iMCIgeDI9IjIyIiB5Mj0iMCIgc3Ryb2tlPSIjMzMzIiBzdHJva2Utd2lkdGg9IjQiLz48bGluZSB4MT0iLTE4IiB5MT0iLTUiIHgyPSIxOCIgeTI9Ii01IiBzdHJva2U9IiMzMzMiIHN0cm9rZS13aWR0aD0iMiIvPjwvZz48L3N2Zz4=',
    options: ['A. 乙烯分子中所有原子共直线', 'B. 乙烯分子是平面结构，键角约为120°', 'C. 乙烯分子呈正四面体结构', 'D. 乙烯中C=C键能是C-C键能的2倍'],
    correctAnswer: 'B',
    explanation: '乙烯分子是平面结构，碳原子采取sp2杂化，键角约为120°，所有原子共平面。C=C键能约为C-C键能的1.5倍。',
    knowledgePoint: '乙烯结构',
    tags: ['结构', '乙烯', '图形题', '难度2', '课本P28']
  },
  {
    id: 'q113',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 3,
    content: '观察乙醇分子的球棍模型（如图所示），下列说法正确的是（ ）',
    image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48IS0tIEV0aGFub2wg6L2s6L2u5byA5Y+Z5pa55rOU5oqA5pytIC0tPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDQwLDEwMCkiPjwhLS0gQyAtLT48Y2lyY2xlIGN4PSIwIiBjeT0iMCIgcj0iMjAiIGZpbGw9IiMzMzMiLz48dGV4dCB4PSIwIiB5PSI1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSIgZm9udC1zaXplPSIxNCI+QzwvdGV4dD48IS0tIEMgLS0+PGNpcmNsZSBjeD0iNjAiIGN5PSIwIiByPSIyMCIgZmlsbD0iIzMzMyIvPjx0ZXh0IHg9IjYwIiB5PSI1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSIgZm9udC1zaXplPSIxNCI+QzwvdGV4dD48IS0tIE8gLS0+PGNpcmNsZSBjeD0iLTEwMCIgY3k9IjAiIHI9IjE4IiBmaWxsPSIjZjAwIi8+PHRleHQgeD0iLTEwMCIgeT0iNSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiIGZvbnQtc2l6ZT0iMTQiPk88L3RleHQ+PGNpcmNsZSBjeD0iLTE0MCIgY3k9IjAiIHI9IjE1IiBmaWxsPSIjZmZmIi8+PHRleHQgeD0iLTE0MCIgeT0iNSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0iIzMzMyIgZm9udC1zaXplPSIxMiI+SDwvdGV4dD48IS0tIEggLS0+PGNpcmNsZSBjeD0iMCIgY3k9Ii00MCIgcj0iMTUiIGZpbGw9IiNmZmYiLz48dGV4dCB4PSIwIiB5PSItMzUiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTIiPkg8L3RleHQ+PGNpcmNsZSBjeD0iMCIgY3k9IjQwIiByPSIxNSIgZmlsbD0iI2ZmZiIvPjx0ZXh0IHg9IjAiIHk9IjQ1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjMzMzIiBmb250LXNpemU9IjEyIj5IPC90ZXh0PjwhLS0gSCAtLT48Y2lyY2xlIGN4PSI2MCIgY3k9Ii00MCIgcj0iMTUiIGZpbGw9IiNmZmYiLz48dGV4dCB4PSI2MCIgeT0iLTM1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjMzMzIiBmb250LXNpemU9IjEyIj5IPC90ZXh0PjxjaXJjbGUgY3g9IjYwIiBjeT0iNDAiIHI9IjE1IiBmaWxsPSIjZmZmIi8+PHRleHQgeD0iNjAiIHk9IjQ1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjMzMzIiBmb250LXNpemU9IjEyIj5IPC90ZXh0PjwhLS0gSCAtLT48Y2lyY2xlIGN4PSIxMDAiIGN5PSIwIiByPSIxNSIgZmlsbD0iI2ZmZiIvPjx0ZXh0IHg9IjEwMCIgeT0iNSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0iIzMzMyIgZm9udC1zaXplPSIxMiI+SDwvdGV4dD48IS0tIOWwmuS5oCAtLT48bGluZSB4MT0iLTIwIiB5MT0iMCIgeDI9Ii04MiIgeTI9IjAiIHN0cm9rZT0iIzk5OSIgc3Ryb2tlLXdpZHRoPSIzIi8+PGxpbmUgeDE9IjIwIiB5MT0iMCIgeDI9IjQwIiB5Mj0iMCIgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjMiLz48bGluZSB4MT0iMCIgeTE9Ii0yMCIgeDI9IjAiIHkyPSItMjUiIHN0cm9rZT0iIzk5OSIgc3Ryb2tlLXdpZHRoPSIzIi8+PGxpbmUgeDE9IjAiIHkxPSIyMCIgeDI9IjAiIHkyPSIyNSIgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjMiLz48bGluZSB4MT0iNjAiIHkxPSItMjAiIHgyPSI2MCIgeTI9Ii0yNSIgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjMiLz48bGluZSB4MT0iNjAiIHkxPSIyMCIgeDI9IjYwIiB5Mj0iMjUiIHN0cm9rZT0iIzk5OSIgc3Ryb2tlLXdpZHRoPSIzIi8+PGxpbmUgeDE9IjgwIiB5MT0iMCIgeDI9Ijg1IiB5Mj0iMCIgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjMiLz48bGluZSB4MT0iLTEyMCIgeTE9IjAiIHgyPSItMTI1IiB5Mj0iMCIgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjMiLz48L2c+PC9zdmc+',
    options: ['A. 乙醇分子中所有原子共平面', 'B. 乙醇含有羟基官能团', 'C. 乙醇是离子化合物', 'D. 乙醇分子中碳原子都是sp2杂化'],
    correctAnswer: 'B',
    explanation: '从球棍模型可以看出，乙醇含有-OH（羟基）官能团。乙醇分子中甲基碳为sp3杂化，所有原子不可能共平面；乙醇是共价化合物。',
    knowledgePoint: '乙醇结构',
    tags: ['结构', '乙醇', '图形题', '难度3', '课本P61']
  },
  {
    id: 'q114',
    chapter: 2,
    section: '2-2',
    type: 'single',
    difficulty: 3,
    content: '观察乙醛分子的结构示意图（如图所示），下列说法正确的是（ ）',
    image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48IS0tIEFjZXRhbGRlaHlkZS3ovazovb7lvIDlj5nmlrnms5TmioDmnK0gLS0+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNDAsMTAwKSI+PGNpcmNsZSBjeD0iMCIgY3k9IjAiIHI9IjIwIiBmaWxsPSIjMzMzIi8+PHRleHQgeD0iMCIgeT0iNSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiIGZvbnQtc2l6ZT0iMTQiPkM8L3RleHQ+PGNpcmNsZSBjeD0iNjAiIGN5PSIwIiByPSIyMCIgZmlsbD0iIzMzMyIvPjx0ZXh0IHg9IjYwIiB5PSI1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSIgZm9udC1zaXplPSIxNCI+QzwvdGV4dD48Y2lyY2xlIGN4PSIxMjAiIGN5PSIwIiByPSIxOCIgZmlsbD0iI2YwMCIvPjx0ZXh0IHg9IjEyMCIgeT0iNSIgdGV4dC1hbmNob3I9Im1pZGRsZSIgZmlsbD0id2hpdGUiIGZvbnQtc2l6ZT0iMTQiPk88L3RleHQ+PGNpcmNsZSBjeD0iMCIgY3k9Ii00MCIgcj0iMTUiIGZpbGw9IiNmZmYiLz48dGV4dCB4PSIwIiB5PSItMzUiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTIiPkg8L3RleHQ+PGNpcmNsZSBjeD0iMCIgY3k9IjQwIiByPSIxNSIgZmlsbD0iI2ZmZiIvPjx0ZXh0IHg9IjAiIHk9IjQ1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjMzMzIiBmb250LXNpemU9IjEyIj5IPC90ZXh0PjxjaXJjbGUgY3g9IjYwIiBjeT0iLTQwIiByPSIxNSIgZmlsbD0iI2ZmZiIvPjx0ZXh0IHg9IjYwIiB5PSItMzUiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTIiPkg8L3RleHQ+PGNpcmNsZSBjeD0iMTYwIiBjeT0iMCIgcj0iMTUiIGZpbGw9IiNmZmYiLz48dGV4dCB4PSIxNjAiIHk9IjUiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTIiPkg8L3RleHQ+PGxpbmUgeDE9IjIwIiB5MT0iMCIgeDI9IjQwIiB5Mj0iMCIgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjMiLz48bGluZSB4MT0iODAiIHkxPSIwIiB4Mj0iMTAyIiB5Mj0iMCIgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjMiLz48bGluZSB4MT0iMTM4IiB5MT0iMCIgeDI9IjE0NSIgeTI9IjAiIHN0cm9rZT0iIzk5OSIgc3Ryb2tlLXdpZHRoPSIzIi8+PGxpbmUgeDE9IjAiIHkxPSItMjAiIHgyPSIwIiB5Mj0iLTI1IiBzdHJva2U9IiM5OTkiIHN0cm9rZS13aWR0aD0iMyIvPjxsaW5lIHgxPSIwIiB5MT0iMjAiIHgyPSIwIiB5Mj0iMjUiIHN0cm9rZT0iIzk5OSIgc3Ryb2tlLXdpZHRoPSIzIi8+PGxpbmUgeDE9IjYwIiB5MT0iLTIwIiB4Mj0iNjAiIHkyPSItMjUiIHN0cm9rZT0iIzk5OSIgc3Ryb2tlLXdpZHRoPSIzIi8+PGxpbmUgeDE9IjEzNSIgeTE9Ii0xMCIgeDI9IjE1NSIgeTI9Ii0xMCIgc3Ryb2tlPSIjMzMzIiBzdHJva2Utd2lkdGg9IjIiLz48L2c+PC9zdmc+',
    options: ['A. 乙醛分子中所有原子共平面', 'B. 乙醛含有醛基(-CHO)官能团', 'C. 乙醛是离子化合物', 'D. 乙醛不能发生加成反应'],
    correctAnswer: 'B',
    explanation: '从结构示意图可以看出，乙醛含有醛基（-CHO）官能团。乙醛分子中甲基碳为sp3杂化，所有原子不共平面；乙醛是共价化合物；醛基能与H2发生加成反应。',
    knowledgePoint: '乙醛结构',
    tags: ['结构', '乙醛', '图形题', '难度3', '课本P75']
  },
  {
    id: 'q115',
    chapter: 2,
    section: '2-3',
    type: 'single',
    difficulty: 3,
    content: '观察乙酸分子的结构示意图（如图所示），下列说法正确的是（ ）',
    image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjgwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48IS0tIEFjZXRpYyBhY2lkIOW8gOWPmeaWueazlOaKgOacrCAtLT48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0MCwxMDApIj48Y2lyY2xlIGN4PSIwIiBjeT0iMCIgcj0iMjAiIGZpbGw9IiMzMzMiLz48dGV4dCB4PSIwIiB5PSI1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSIgZm9udC1zaXplPSIxNCI+QzwvdGV4dD48Y2lyY2xlIGN4PSI2MCIgY3k9IjAiIHI9IjIwIiBmaWxsPSIjMzMzIi8+PHRleHQgeD0iNjAiIHk9IjUiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IndoaXRlIiBmb250LXNpemU9IjE0Ij5DPC90ZXh0PjxjaXJjbGUgY3g9IjEyMCIgY3k9IjAiIHI9IjE4IiBmaWxsPSIjZjAwIi8+PHRleHQgeD0iMTIwIiB5PSI1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSJ3aGl0ZSIgZm9udC1zaXplPSIxNCI+TzwvdGV4dD48Y2lyY2xlIGN4PSIxNzAiIGN5PSItMzAiIHI9IjE1IiBmaWxsPSIjZmZmIi8+PHRleHQgeD0iMTcwIiB5PSItMjUiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTIiPkg8L3RleHQ+PGNpcmNsZSBjeD0iMCIgY3k9Ii00MCIgcj0iMTUiIGZpbGw9IiNmZmYiLz48dGV4dCB4PSIwIiB5PSItMzUiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTIiPkg8L3RleHQ+PGNpcmNsZSBjeD0iMCIgY3k9IjQwIiByPSIxNSIgZmlsbD0iI2ZmZiIvPjx0ZXh0IHg9IjAiIHk9IjQ1IiB0ZXh0LWFuY2hvcj0ibWlkZGxlIiBmaWxsPSIjMzMzIiBmb250LXNpemU9IjEyIj5IPC90ZXh0PjxjaXJjbGUgY3g9IjYwIiBjeT0iLTQwIiByPSIxNSIgZmlsbD0iI2ZmZiIvPjx0ZXh0IHg9IjYwIiB5PSItMzUiIHRleHQtYW5jaG9yPSJtaWRkbGUiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTIiPkg8L3RleHQ+PGxpbmUgeDE9IjIwIiB5MT0iMCIgeDI9IjQwIiB5Mj0iMCIgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjMiLz48bGluZSB4MT0iODAiIHkxPSIwIiB4Mj0iMTAyIiB5Mj0iMCIgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjMiLz48bGluZSB4MT0iMTM4IiB5MT0iMCIgeDI9IjE1NSIgeTI9Ii0xNSIgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjMiLz48bGluZSB4MT0iMCIgeTE9Ii0yMCIgeDI9IjAiIHkyPSItMjUiIHN0cm9rZT0iIzk5OSIgc3Ryb2tlLXdpZHRoPSIzIi8+PGxpbmUgeDE9IjAiIHkxPSIyMCIgeDI9IjAiIHkyPSIyNSIgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjMiLz48bGluZSB4MT0iNjAiIHkxPSItMjAiIHgyPSI2MCIgeTI9Ii0yNSIgc3Ryb2tlPSIjOTk5IiBzdHJva2Utd2lkdGg9IjMiLz48bGluZSB4MT0iMTM1IiB5MT0iLTIwIiB4Mj0iMTU1IiB5Mj0iLTQwIiBzdHJva2U9IiMzMzMiIHN0cm9rZS13aWR0aD0iMiIvPjwvZz48L3N2Zz4=',
    options: ['A. 乙酸分子中所有原子共平面', 'B. 乙酸含有羧基(-COOH)官能团', 'C. 乙酸是强酸', 'D. 乙酸不能发生酯化反应'],
    correctAnswer: 'B',
    explanation: '从结构示意图可以看出，乙酸含有羧基（-COOH）官能团。乙酸分子中甲基碳为sp3杂化，所有原子不共平面；乙酸是弱酸；乙酸能与醇发生酯化反应。',
    knowledgePoint: '乙酸结构',
    tags: ['结构', '乙酸', '图形题', '难度3', '课本P82']
  },
  {
    id: 'q116',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 4,
    content: '观察下列有机物的键线式，分子式为C6H14的是（ ）',
    image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjE1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGV4dCB4PSIyMCIgeT0iMjAiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTQiPkE8L3RleHQ+PHBhdGggZD0iTTQwLDgwIEw4MCw4MCBMMTAwLDUwIEwxMjAsODAgTDE2MCw4MCIgc3Ryb2tlPSIjMzMzIiBzdHJva2Utd2lkdGg9IjMiIGZpbGw9Im5vbmUiLz48Y2lyY2xlIGN4PSI0MCIgY3k9IjgwIiByPSI0IiBmaWxsPSIjMzMzIi8+PGNpcmNsZSBjeD0iODAiIGN5PSI4MCIgcj0iNCIgZmlsbD0iIzMzMyIvPjxjaXJjbGUgY3g9IjEwMCIgY3k9IjUwIiByPSI0IiBmaWxsPSIjMzMzIi8+PGNpcmNsZSBjeD0iMTIwIiBjeT0iODAiIHI9IjQiIGZpbGw9IiMzMzMiLz48Y2lyY2xlIGN4PSIxNjAiIGN5PSI4MCIgcj0iNCIgZmlsbD0iIzMzMyIvPjx0ZXh0IHg9IjIwMCIgeT0iMjAiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTQiPkI8L3RleHQ+PHBhdGggZD0iTTIyMCw4MCBMMjYwLDgwIEwyODAsNTAgTDMwMCw4MCBMMzQwLDgwIiBzdHJva2U9IiMzMzMiIHN0cm9rZS13aWR0aD0iMyIgZmlsbD0ibm9uZSIvPjxjaXJjbGUgY3g9IjIyMCIgY3k9IjgwIiByPSI0IiBmaWxsPSIjMzMzIi8+PGNpcmNsZSBjeD0iMjYwIiBjeT0iODAiIHI9IjQiIGZpbGw9IiMzMzMiLz48Y2lyY2xlIGN4PSIyODAiIGN5PSI1MCIgcj0iNCIgZmlsbD0iIzMzMyIvPjxjaXJjbGUgY3g9IjMwMCIgY3k9IjgwIiByPSI0IiBmaWxsPSIjMzMzIi8+PGNpcmNsZSBjeD0iMzQwIiBjeT0iODAiIHI9IjQiIGZpbGw9IiMzMzMiLz48L3N2Zz4=',
    options: ['A. 只有A', 'B. 只有B', 'C. A和B都是', 'D. A和B都不是'],
    correctAnswer: 'C',
    explanation: '键线式中每个端点和拐点代表一个碳原子。A和B都是含有6个碳原子的烷烃，分子式都是C6H14。A是2-甲基戊烷，B是3-甲基戊烷。',
    knowledgePoint: '键线式识别',
    tags: ['结构', '键线式', '图形题', '难度4', '课本P8']
  },
  {
    id: 'q117',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 4,
    content: '观察下列反应的能量变化图，下列说法正确的是（ ）',
    image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjI1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48IS0tIOaWsOeJuOeUqOeJueauiuWJj+W8gOWPmeaWueazlOaKgOacrCAtLT48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0MCwyMCkiPjx0ZXh0IHg9IjAiIHk9IjE4MCIgZmlsbD0iIzMzMyIgZm9udC1zaXplPSIxMiI+5byA5Y+Z6YePPC90ZXh0Pjx0ZXh0IHg9IjIwMCIgeT0iMTgwIiBmaWxsPSIjMzMzIiBmb250LXNpemU9IjEyIj7nlKjlnYs8L3RleHQ+PHRleHQgeD0iLTMwIiB5PSIxNTAiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTAiPuW5tOW6pjwvdGV4dD48dGV4dCB4PSItMzAiIHk9IjUwIiBmaWxsPSIjMzMzIiBmb250LXNpemU9IjEwIj7ogqXmlpnnlKjlnYs8L3RleHQ+PHBhdGggZD0iTTQwLDE1MCBRODAsMTUwIDEwMCwxMDAgVDE2MCw1MCIgc3Ryb2tlPSIjZjAwIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9Im5vbmUiLz48Y2lyY2xlIGN4PSI0MCIgY3k9IjE1MCIgcj0iNCIgZmlsbD0iIzMzMyIvPjxjaXJjbGUgY3g9IjE2MCIgY3k9IjUwIiByPSI0IiBmaWxsPSIjMzMzIi8+PGxpbmUgeDE9IjQwIiB5MT0iMTUwIiB4Mj0iNDAiIHkyPSIxNzAiIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLXdpZHRoPSIxIiBzdHJva2UtZGFzaGFycmF5PSI1LDUiLz48bGluZSB4MT0iMTYwIiB5MT0iNTAiIHgyPSIxNjAiIHkyPSIxNzAiIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLXdpZHRoPSIxIiBzdHJva2UtZGFzaGFycmF5PSI1LDUiLz48bGluZSB4MT0iNDAiIHkxPSIxNzAiIHgyPSIxNjAiIHkyPSIxNzAiIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLXdpZHRoPSIxIi8+PHRleHQgeD0iMTAwIiB5PSIyMDAiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTAiPuWcsOWdgOaKgOacrzwvdGV4dD48L2c+PC9zdmc+',
    options: ['A. 该反应是放热反应', 'B. 反应物总能量高于生成物总能量', 'C. 该反应需要吸收能量', 'D. 反应过程中不需要活化能'],
    correctAnswer: 'C',
    explanation: '从能量变化图可以看出，生成物总能量高于反应物总能量，说明该反应是吸热反应，需要吸收能量。反应过程中需要克服活化能垒。',
    knowledgePoint: '反应能量变化',
    tags: ['能量', '反应热', '图形题', '难度4', '课本P30']
  },
  {
    id: 'q118',
    chapter: 1,
    section: '1-2',
    type: 'single',
    difficulty: 3,
    content: '观察下列烷烃的沸点变化曲线图，下列说法正确的是（ ）',
    image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAwIiBoZWlnaHQ9IjI1MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0MCwyMCkiPjx0ZXh0IHg9Ii0yMCIgeT0iMTAiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTAiPuWJj+WcsOWdgOaWsOeJuOeUqOaWme+8mjEwMPCfk0M8L3RleHQ+PHRleHQgeD0iMjAiIHk9IjE4MCIgZmlsbD0iIzMzMyIgZm9udC1zaXplPSIxMCI+5Y+3PC90ZXh0Pjx0ZXh0IHg9IjgwIiB5PSIxODAiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTAiPuWNgTwvdGV4dD48dGV4dCB4PSIxNDAiIHk9IjE4MCIgZmlsbD0iIzMzMyIgZm9udC1zaXplPSIxMCI+5LqnPC90ZXh0Pjx0ZXh0IHg9IjIwMCIgeT0iMTgwIiBmaWxsPSIjMzMzIiBmb250LXNpemU9IjEwIj7lubQ8L3RleHQ+PHBhdGggZD0iTTQwLDE1MCBMMTAwLDEyMCBMMTYwLDkwIEwyMjAsNjAiIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLXdpZHRoPSIyIiBmaWxsPSJub25lIi8+PGNpcmNsZSBjeD0iNDAiIGN5PSIxNTAiIHI9IjQiIGZpbGw9IiNmMDAiLz48Y2lyY2xlIGN4PSIxMDAiIGN5PSIxMjAiIHI9IjQiIGZpbGw9IiNmMDAiLz48Y2lyY2xlIGN4PSIxNjAiIGN5PSI5MCIgcj0iNCIgZmlsbD0iI2YwMCIvPjxjaXJjbGUgY3g9IjIyMCIgY3k9IjYwIiByPSI0IiBmaWxsPSIjZjAwIi8+PGxpbmUgeDE9IjIwIiB5MT0iMTcwIiB4Mj0iMjQwIiB5Mj0iMTcwIiBzdHJva2U9IiMzMzMiIHN0cm9rZS13aWR0aD0iMSIvPjxsaW5lIHgxPSI0MCIgeTE9IjQwIiB4Mj0iNDAiIHkyPSIxNzAiIHN0cm9rZT0iIzMzMyIgc3Ryb2tlLXdpZHRoPSIxIi8+PC9nPjwvc3ZnPg==',
    options: ['A. 烷烃沸点随碳原子数增加而降低', 'B. 甲烷沸点最高', 'C. 烷烃沸点随碳原子数增加而升高', 'D. 同碳数烷烃，支链越多沸点越高'],
    correctAnswer: 'C',
    explanation: '从曲线图可以看出，烷烃沸点随碳原子数增加而升高（甲烷→乙烷→丙烷→丁烷）。同碳数时，支链越多沸点越低。',
    knowledgePoint: '烷烃沸点规律',
    tags: ['物理性质', '烷烃', '图形题', '难度3', '课本P24']
  },
  {
    id: 'q119',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 4,
    content: '观察乙醇和二甲醚的结构对比图，下列说法正确的是（ ）',
    image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjIwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGV4dCB4PSI0MCIgeT0iMzAiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTQiPuW8gOWPmeaWueazlOaWsOeJuOeUqOaWme+8jOW8gOWPmeaWueazlOW8gOWPmeaWueazlOW8gOWPmeaWueazlTwvdGV4dD48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSg0MCw2MCkiPjx0ZXh0IHg9IjYwIiB5PSIwIiBmaWxsPSIjMzMzIiBmb250LXNpemU9IjE0Ij5DSDNDSDJPSCDlvIDlj5nmlrnms5U8L3RleHQ+PHBhdGggZD0iTTQwLDQwIEw2MCw0MCBMODAsMjAgTDEwMCw0MCIgc3Ryb2tlPSIjMzMzIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9Im5vbmUiLz48Y2lyY2xlIGN4PSI0MCIgY3k9IjQwIiByPSI0IiBmaWxsPSIjMzMzIi8+PGNpcmNsZSBjeD0iNjAiIGN5PSI0MCIgcj0iNCIgZmlsbD0iIzMzMyIvPjxjaXJjbGUgY3g9IjgwIiBjeT0iMjAiIHI9IjQiIGZpbGw9IiNmMDAiLz48Y2lyY2xlIGN4PSIxMDAiIGN5PSI0MCIgcj0iNCIgZmlsbD0iIzMzMyIvPjwvZz48ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyMjAsNjApIj48dGV4dCB4PSI2MCIgeT0iMCIgZmlsbD0iIzMzMyIgZm9udC1zaXplPSIxNCI+Q0gzT0NIMyDlvIDlj5nmlrnms5Xlj4w8L3RleHQ+PHBhdGggZD0iTTQwLDQwIEw2MCw0MCBMODAsNDAgTDEwMCw0MCIgc3Ryb2tlPSIjMzMzIiBzdHJva2Utd2lkdGg9IjIiIGZpbGw9Im5vbmUiLz48Y2lyY2xlIGN4PSI0MCIgY3k9IjQwIiByPSI0IiBmaWxsPSIjMzMzIi8+PGNpcmNsZSBjeD0iNjAiIGN5PSI0MCIgcj0iNCIgZmlsbD0iI2YwMCIvPjxjaXJjbGUgY3g9IjgwIiBjeT0iNDAiIHI9IjQiIGZpbGw9IiMzMzMiLz48Y2lyY2xlIGN4PSIxMDAiIGN5PSI0MCIgcj0iNCIgZmlsbD0iIzMzMyIvPjwvZz48L3N2Zz4=',
    options: ['A. 乙醇和二甲醚是同一种物质', 'B. 乙醇和二甲醚互为同分异构体', 'C. 乙醇和二甲醚分子式不同', 'D. 乙醇和二甲醚性质完全相同'],
    correctAnswer: 'B',
    explanation: '乙醇（CH3CH2OH）和二甲醚（CH3OCH3）分子式都是C2H6O，但结构不同，互为同分异构体。由于官能团不同，性质差异很大。',
    knowledgePoint: '同分异构体',
    tags: ['同分异构', '醇醚', '图形题', '难度4', '课本P6']
  },
  {
    id: 'q120',
    chapter: 1,
    section: '1-3',
    type: 'single',
    difficulty: 4,
    content: '观察下列有机物的结构简式，属于炔烃的是（ ）',
    image: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAwIiBoZWlnaHQ9IjE4MCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48dGV4dCB4PSI0MCIgeT0iNDAiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTQiPkE6IENIMy1DSCAyQ0gzPC90ZXh0Pjx0ZXh0IHg9IjQwIiB5PSI4MCIgZmlsbD0iIzMzMyIgZm9udC1zaXplPSIxNCI+QjogQ0gzQyDzQ0gzPC90ZXh0Pjx0ZXh0IHg9IjQwIiB5PSIxMjAiIGZpbGw9IiMzMzMiIGZvbnQtc2l6ZT0iMTQiPkM6IENIMy1DSD1DSENIMzwvdGV4dD48dGV4dCB4PSI0MCIgeT0iMTYwIiBmaWxsPSIjMzMzIiBmb250LXNpemU9IjE0Ij5EOiBDSDMtQyDzQy1DSDM8L3RleHQ+PC9zdmc+',
    options: ['A. 只有A', 'B. 只有B', 'C. A和C', 'D. B和D'],
    correctAnswer: 'D',
    explanation: '炔烃含有碳碳三键（C≡C）。A是乙烷（烷烃），B是乙炔（炔烃），C是丙烯（烯烃），D是丙炔（炔烃）。所以B和D是炔烃。',
    knowledgePoint: '炔烃识别',
    tags: ['分类', '炔烃', '图形题', '难度4', '课本P33']
  },

  // ============================================
  // 实验题目 (15题)
  // ============================================
  {
    id: 'q121',
    chapter: 1,
    section: '1-2',
    type: 'experiment',
    difficulty: 2,
    content: '实验室制取甲烷时，常用的药品是（ ）',
    options: ['A. 乙酸钠和碱石灰', 'B. 无水醋酸钠和碱石灰', 'C. 醋酸钠和氢氧化钠', 'D. 无水醋酸钠和生石灰'],
    correctAnswer: 'B',
    explanation: '实验室制取甲烷使用无水醋酸钠和碱石灰（氢氧化钠与氧化钙的混合物）混合加热。碱石灰中的CaO可以吸收水分，防止NaOH与玻璃反应，同时使反应混合物疏松，利于气体逸出。',
    knowledgePoint: '甲烷的实验室制法',
    tags: ['实验', '甲烷制备', '难度2', '课本P26']
  },
  {
    id: 'q122',
    chapter: 1,
    section: '1-2',
    type: 'experiment',
    difficulty: 3,
    content: '甲烷与氯气在光照下发生取代反应，实验现象是（ ）',
    options: ['A. 气体颜色变浅，瓶壁有油状液滴', 'B. 气体颜色加深，有白雾生成', 'C. 无明显变化', 'D. 有爆炸声'],
    correctAnswer: 'A',
    explanation: '甲烷与氯气在光照下发生取代反应，氯气被消耗，黄绿色变浅；生成的氯代甲烷中除一氯甲烷外都是油状液体，会在瓶壁凝结成油状液滴；同时生成的HCl遇水蒸气形成白雾。',
    knowledgePoint: '甲烷取代反应实验',
    tags: ['实验', '取代反应', '难度3', '课本P26']
  },
  {
    id: 'q123',
    chapter: 1,
    section: '1-3',
    type: 'experiment',
    difficulty: 2,
    content: '鉴别甲烷和乙烯，可使用的试剂是（ ）',
    options: ['A. 水', 'B. 溴水', 'C. 盐酸', 'D. 食盐水'],
    correctAnswer: 'B',
    explanation: '乙烯含有碳碳双键，能与溴水发生加成反应使溴水褪色；甲烷与溴水不反应。因此可用溴水鉴别甲烷和乙烯。',
    knowledgePoint: '烯烃的鉴别',
    tags: ['实验', '鉴别', '难度2', '课本P29']
  },
  {
    id: 'q124',
    chapter: 1,
    section: '1-3',
    type: 'experiment',
    difficulty: 3,
    content: '实验室制取乙烯时，温度计的水银球应插入（ ）',
    options: ['A. 反应液中', 'B. 液面上方', 'C. 导管口', 'D. 收集瓶中'],
    correctAnswer: 'A',
    explanation: '实验室制取乙烯需要控制反应温度在170℃，温度计水银球应插入反应液中，以准确测量反应液的温度。',
    knowledgePoint: '乙烯的实验室制法',
    tags: ['实验', '乙烯制备', '难度3', '课本P30']
  },
  {
    id: 'q125',
    chapter: 1,
    section: '1-4',
    type: 'experiment',
    difficulty: 3,
    content: '苯与液溴在FeBr₃催化下反应，实验装置中需要（ ）',
    options: ['A. 长导管起冷凝回流作用', 'B. 直接加热', 'C. 水浴加热', 'D. 不需要催化剂'],
    correctAnswer: 'A',
    explanation: '苯与液溴反应剧烈放热，溴和苯都易挥发，使用长导管可以起冷凝回流作用，使挥发的溴和苯蒸气冷凝回流到反应容器中，提高原料利用率。',
    knowledgePoint: '苯的溴代反应',
    tags: ['实验', '取代反应', '难度3', '课本P40']
  },
  {
    id: 'q126',
    chapter: 2,
    section: '2-1',
    type: 'experiment',
    difficulty: 2,
    content: '乙醇与金属钠反应，观察到的现象是（ ）',
    options: ['A. 剧烈反应，产生大量气泡', 'B. 缓慢反应，产生气泡', 'C. 无明显现象', 'D. 钠浮在液面上'],
    correctAnswer: 'B',
    explanation: '乙醇与金属钠反应比水与钠反应缓慢，产生氢气气泡，钠沉在乙醇底部（乙醇密度小于钠）。反应方程式：2C₂H₅OH + 2Na → 2C₂H₅ONa + H₂↑',
    knowledgePoint: '乙醇与钠反应',
    tags: ['实验', '醇的性质', '难度2', '课本P63']
  },
  {
    id: 'q127',
    chapter: 2,
    section: '2-1',
    type: 'experiment',
    difficulty: 3,
    content: '乙醇的催化氧化实验中，铜丝的现象是（ ）',
    options: ['A. 铜丝变黑，趁热插入乙醇中又变红', 'B. 铜丝一直变黑', 'C. 铜丝无变化', 'D. 铜丝溶解'],
    correctAnswer: 'A',
    explanation: '铜丝在酒精灯上加热表面氧化变黑（生成CuO），趁热插入乙醇中，CuO被乙醇还原为Cu，铜丝又变红。总反应：2CH₃CH₂OH + O₂ → 2CH₃CHO + 2H₂O（Cu催化）',
    knowledgePoint: '乙醇的催化氧化',
    tags: ['实验', '氧化反应', '难度3', '课本P64']
  },
  {
    id: 'q128',
    chapter: 2,
    section: '2-1',
    type: 'experiment',
    difficulty: 3,
    content: '苯酚与FeCl₃溶液反应，现象是（ ）',
    options: ['A. 产生白色沉淀', 'B. 溶液变紫色', 'C. 产生气泡', 'D. 无明显变化'],
    correctAnswer: 'B',
    explanation: '苯酚与FeCl₃溶液发生显色反应，溶液变为紫色。这是酚类化合物的特征反应，可用于鉴别酚类。',
    knowledgePoint: '苯酚的显色反应',
    tags: ['实验', '酚的性质', '难度3', '课本P68']
  },
  {
    id: 'q129',
    chapter: 2,
    section: '2-2',
    type: 'experiment',
    difficulty: 2,
    content: '乙醛发生银镜反应，需要加入的试剂是（ ）',
    options: ['A. 银氨溶液', 'B. 硝酸银溶液', 'C. 氯化银', 'D. 硫酸银'],
    correctAnswer: 'A',
    explanation: '银镜反应使用银氨溶液（[Ag(NH₃)₂]OH），乙醛被氧化为乙酸，Ag⁺被还原为Ag，在试管壁形成银镜。',
    knowledgePoint: '银镜反应',
    tags: ['实验', '醛的性质', '难度2', '课本P77']
  },
  {
    id: 'q130',
    chapter: 2,
    section: '2-2',
    type: 'experiment',
    difficulty: 3,
    content: '乙醛与新制Cu(OH)₂反应，需要的条件是（ ）',
    options: ['A. 常温', 'B. 加热煮沸', 'C. 光照', 'D. 加压'],
    correctAnswer: 'B',
    explanation: '乙醛与新制Cu(OH)₂反应需要加热煮沸条件，生成红色的Cu₂O沉淀。这是醛基的特征反应，可用于鉴别醛类。',
    knowledgePoint: '醛的氧化反应',
    tags: ['实验', '醛的性质', '难度3', '课本P77']
  },
  {
    id: 'q131',
    chapter: 2,
    section: '2-3',
    type: 'experiment',
    difficulty: 2,
    content: '乙酸与碳酸钠反应，观察到的现象是（ ）',
    options: ['A. 产生气泡', 'B. 产生沉淀', 'C. 溶液变色', 'D. 无明显变化'],
    correctAnswer: 'A',
    explanation: '乙酸酸性强于碳酸，与碳酸钠反应生成二氧化碳气体，产生气泡。反应方程式：2CH₃COOH + Na₂CO₃ → 2CH₃COONa + H₂O + CO₂↑',
    knowledgePoint: '乙酸的酸性',
    tags: ['实验', '羧酸性质', '难度2', '课本P83']
  },
  {
    id: 'q132',
    chapter: 2,
    section: '2-3',
    type: 'experiment',
    difficulty: 3,
    content: '乙酸乙酯的制备实验中，浓硫酸的作用是（ ）',
    options: ['A. 只作催化剂', 'B. 催化剂和吸水剂', 'C. 只作吸水剂', 'D. 氧化剂'],
    correctAnswer: 'B',
    explanation: '乙酸乙酯制备中，浓硫酸既作催化剂加快反应速率，又作吸水剂吸收生成的水，使平衡向生成酯的方向移动，提高产率。',
    knowledgePoint: '酯化反应',
    tags: ['实验', '酯化反应', '难度3', '课本P87']
  },
  {
    id: 'q133',
    chapter: 2,
    section: '2-3',
    type: 'experiment',
    difficulty: 3,
    content: '鉴别乙酸、乙醇、苯酚三种溶液，可选用的试剂是（ ）',
    options: ['A. 溴水', 'B. NaHCO₃溶液和FeCl₃溶液', 'C. 银氨溶液', 'D. 盐酸'],
    correctAnswer: 'B',
    explanation: '用NaHCO₃溶液鉴别：乙酸反应产生气泡（CO₂），乙醇和苯酚不反应；再用FeCl₃溶液鉴别：苯酚显紫色，乙醇无现象。',
    knowledgePoint: '物质鉴别',
    tags: ['实验', '鉴别', '难度3', '课本P83-87']
  },
  {
    id: 'q134',
    chapter: 2,
    section: '2-4',
    type: 'experiment',
    difficulty: 4,
    content: '某有机物能使酸性KMnO₄溶液褪色，也能使溴水褪色，该有机物可能是（ ）',
    options: ['A. 乙烷', 'B. 乙烯', 'C. 苯', 'D. 乙酸'],
    correctAnswer: 'B',
    explanation: '乙烯含有碳碳双键，能被酸性KMnO₄氧化使溶液褪色，也能与溴水发生加成反应使溴水褪色。乙烷、苯、乙酸都不能使两种溶液褪色。',
    knowledgePoint: '烯烃的性质',
    tags: ['实验', '性质检验', '难度4', '课本P29']
  },
  {
    id: 'q135',
    chapter: 2,
    section: '2-5',
    type: 'experiment',
    difficulty: 4,
    content: '要检验某有机物中是否含有醛基，可使用的试剂组合是（ ）',
    options: ['A. 银氨溶液或新制Cu(OH)₂', 'B. 溴水', 'C. FeCl₃溶液', 'D. NaHCO₃溶液'],
    correctAnswer: 'A',
    explanation: '醛基的特征反应：①银镜反应（与银氨溶液反应生成银镜）；②与新制Cu(OH)₂加热反应生成红色Cu₂O沉淀。这两种方法都可用于检验醛基。',
    knowledgePoint: '醛基的检验',
    tags: ['实验', '官能团检验', '难度4', '课本P77']
  },

  // ============================================
  // 从2024-2025高二（下）期中试卷提取的题目
  // ============================================
  // 清华附中2024
  {
    id: 'q136',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 2,
    content: '下列有关乙醇的表述不正确的是（ ）',
    options: ['A. 乙醇的实验式和分子式均为C₂H₆O', 'B. 乙醇分子的空间填充模型为四面体结构', 'C. 乙醇分子中官能团的电子式为·O:H', 'D. 乙醇与二甲醚互为同分异构体'],
    correctAnswer: 'A',
    explanation: '乙醇的分子式为C₂H₆O，实验式（最简式）为C₂H₆O，但实验式通常表示原子个数比，乙醇的实验式也是C₂H₆O。选项A表述有问题，因为实验式和分子式虽然形式相同，但概念不同。',
    knowledgePoint: '乙醇的结构与表示',
    tags: ['结构', '乙醇', '清华附中2024', '难度2', '课本P61']
  },
  {
    id: 'q137',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 3,
    content: '下列有机物的系统命名正确的是（ ）',
    options: ['A. 2-乙基丁烷', 'B. 3,3-二甲基丁烷', 'C. 2-甲基-1,3-丁二烯', 'D. 2,2-二甲基-3-戊炔'],
    correctAnswer: 'C',
    explanation: 'A. 2-乙基丁烷错误，主链应选最长碳链，正确名称为3-甲基戊烷；B. 3,3-二甲基丁烷错误，编号应从靠近支链一端开始，正确名称为2,2-二甲基丁烷；C. 2-甲基-1,3-丁二烯命名正确；D. 2,2-二甲基-3-戊炔错误，编号应从靠近官能团一端开始，正确名称为4,4-二甲基-2-戊炔。',
    knowledgePoint: '有机物的系统命名',
    tags: ['命名', '系统命名', '清华附中2024', '难度3', '课本P8-10']
  },
  {
    id: 'q138',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 2,
    content: '下列有机物中，由于分子之间易形成氢键，沸点较高的是（ ）',
    options: ['A. 乙烷', 'B. 乙醇', 'C. 乙酸乙酯', 'D. 甲苯'],
    correctAnswer: 'B',
    explanation: '乙醇分子中含有羟基（-OH），分子间能形成氢键，使沸点显著升高。乙烷、乙酸乙酯、甲苯分子间都不能形成氢键，沸点相对较低。',
    knowledgePoint: '氢键与沸点',
    tags: ['氢键', '沸点', '清华附中2024', '难度2', '课本P63']
  },
  {
    id: 'q139',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 3,
    content: '下列过程中没有发生取代反应的是（ ）',
    options: ['A. 油脂的水解', 'B. 甲苯制TNT的反应', 'C. 乙醛的银镜反应', 'D. 白酒在陈化过程中产生香味'],
    correctAnswer: 'C',
    explanation: 'A. 油脂水解是取代反应；B. 甲苯制TNT是硝化反应，属于取代反应；C. 乙醛的银镜反应是氧化反应，不是取代反应；D. 白酒陈化过程中乙醇被氧化为乙酸，乙酸与乙醇酯化生成乙酸乙酯，涉及取代反应。',
    knowledgePoint: '反应类型判断',
    tags: ['反应类型', '取代反应', '清华附中2024', '难度3', '课本P77']
  },
  {
    id: 'q140',
    chapter: 1,
    section: '1-4',
    type: 'single',
    difficulty: 4,
    content: '有8种物质：①乙烷；②乙烯；③乙炔；④苯；⑤甲苯；⑥溴乙烷；⑦聚丙烯；⑧环己烯。其中既不能使酸性KMnO₄溶液褪色，也不能与溴水反应而使溴水褪色的是（ ）',
    options: ['A. ①②③⑤', 'B. ①④⑥⑦', 'C. ④⑥⑦⑧', 'D. ②③⑤⑧'],
    correctAnswer: 'B',
    explanation: '①乙烷：饱和烃，不能使KMnO₄褪色，不能与溴水反应；④苯：稳定结构，不能使KMnO₄褪色，不能与溴水反应；⑥溴乙烷：卤代烃，不能使KMnO₄褪色，不能与溴水反应；⑦聚丙烯：饱和高分子，不能使KMnO₄褪色，不能与溴水反应。②乙烯、③乙炔、⑧环己烯含不饱和键，能使KMnO₄褪色，能与溴水反应；⑤甲苯能使KMnO₄褪色。',
    knowledgePoint: '有机物的性质',
    tags: ['性质', '鉴别', '清华附中2024', '难度4', '课本P29-40']
  },
  {
    id: 'q141',
    chapter: 2,
    section: '2-5',
    type: 'single',
    difficulty: 3,
    content: '由2-氯丙烷制取少量的1,2-丙二醇时，需要经过下列哪几步反应（ ）',
    options: ['A. 加成→消去→取代', 'B. 消去→加成→水解', 'C. 取代→消去→加成', 'D. 消去→加成→消去'],
    correctAnswer: 'B',
    explanation: '合成路线：2-氯丙烷→丙烯（消去反应）→1,2-二溴丙烷（与Br₂加成）→1,2-丙二醇（水解反应）。所以反应顺序是：消去→加成→水解。',
    knowledgePoint: '有机合成路线',
    tags: ['合成', '路线设计', '清华附中2024', '难度3', '课本P97']
  },
  {
    id: 'q142',
    chapter: 1,
    section: '1-4',
    type: 'single',
    difficulty: 4,
    content: '下列对实验事实的解释不正确的是（ ）',
    options: ['A. 甲苯能使酸性KMnO₄溶液褪色但苯不能——甲基使苯环上的部分H活化', 'B. 甲苯生成邻硝基甲苯比苯生成硝基苯所需温度低——甲基使苯环上的部分H活化', 'C. 苯酚能和浓溴水反应产生白色沉淀但苯不能——羟基使苯环上的部分H活化', 'D. 常温下苯酚与NaOH反应而环己醇不能——苯环使羟基的O-H键极性增强'],
    correctAnswer: 'A',
    explanation: 'A选项解释错误。甲苯能使酸性KMnO₄溶液褪色是因为甲基被氧化，而不是甲基使苯环上的H活化。B、C、D选项解释均正确。',
    knowledgePoint: '有机物结构与性质关系',
    tags: ['结构', '性质', '清华附中2024', '难度4', '课本P41']
  },
  {
    id: 'q143',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 4,
    content: '下列有机物结构与性质分析正确的是（ ）',
    options: ['A. 二甲醚与乙醇互为同系物', 'B. 乙酸乙酯的核磁共振氢谱出现三组峰，且峰面积之比为3:2:3', 'C. 分子式为C₄H₁₀的有机物一氯代物共有6种', 'D. 某有机物含2种官能团'],
    correctAnswer: 'B',
    explanation: 'A. 二甲醚与乙醇分子式相同（C₂H₆O），结构不同，互为同分异构体，不是同系物；B. 乙酸乙酯（CH₃COOCH₂CH₃）有三种等效氢，个数比为3:2:3，核磁共振氢谱出现三组峰，峰面积之比为3:2:3，正确；C. C₄H₁₀有正丁烷和异丁烷两种同分异构体，一氯代物共有4种；D. 需要具体结构才能判断。',
    knowledgePoint: '有机物结构分析',
    tags: ['结构', '核磁共振', '清华附中2024', '难度4', '课本P12-14']
  },
  // 人大附中2024
  {
    id: 'q144',
    chapter: 1,
    section: '1-3',
    type: 'single',
    difficulty: 3,
    content: '下列关于乙烯和乙炔的说法正确的是（ ）',
    options: ['A. 乙烯和乙炔都能使溴水褪色，原理相同', 'B. 乙烯和乙炔都能使酸性KMnO₄溶液褪色，原理相同', 'C. 乙烯和乙炔都能发生加聚反应', 'D. 乙烯和乙炔分子中所有原子都共平面'],
    correctAnswer: 'B',
    explanation: 'A. 乙烯和乙炔使溴水褪色都是加成反应，原理相同；B. 乙烯和乙炔使酸性KMnO₄溶液褪色都是被氧化，原理相同；C. 乙烯能发生加聚反应，乙炔在一定条件下也能发生加聚反应；D. 乙烯所有原子共平面，乙炔所有原子共直线。B选项最准确。',
    knowledgePoint: '乙烯和乙炔的性质',
    tags: ['性质', '烯烃', '炔烃', '人大附中2024', '难度3', '课本P28-33']
  },
  {
    id: 'q145',
    chapter: 2,
    section: '2-2',
    type: 'single',
    difficulty: 3,
    content: '下列关于醛和酮的说法不正确的是（ ）',
    options: ['A. 醛和酮都能与氢气发生加成反应', 'B. 醛能被弱氧化剂氧化，酮不能被弱氧化剂氧化', 'C. 甲醛是唯一的脂肪醛', 'D. 丙酮是常用的有机溶剂'],
    correctAnswer: 'C',
    explanation: 'A. 醛和酮都含有羰基，都能与氢气发生加成反应生成醇；B. 醛能被银氨溶液、新制Cu(OH)₂等弱氧化剂氧化，酮不能；C. 甲醛不是唯一的脂肪醛，还有乙醛、丙醛等；D. 丙酮是常用的有机溶剂，正确。',
    knowledgePoint: '醛和酮的性质',
    tags: ['性质', '醛', '酮', '人大附中2024', '难度3', '课本P75-78']
  },
  {
    id: 'q146',
    chapter: 2,
    section: '2-3',
    type: 'single',
    difficulty: 3,
    content: '下列关于羧酸和酯的说法正确的是（ ）',
    options: ['A. 羧酸的酸性都比碳酸强', 'B. 酯化反应是可逆反应', 'C. 油脂属于酯类，是纯净物', 'D. 甲酸乙酯不能发生银镜反应'],
    correctAnswer: 'B',
    explanation: 'A. 不是所有羧酸酸性都比碳酸强，如苯酚酸性弱于碳酸；B. 酯化反应是可逆反应，正确；C. 油脂是多种高级脂肪酸甘油酯的混合物，不是纯净物；D. 甲酸乙酯含有醛基，能发生银镜反应。',
    knowledgePoint: '羧酸和酯的性质',
    tags: ['性质', '羧酸', '酯', '人大附中2024', '难度3', '课本P82-88']
  },
  // 一零一中2024
  {
    id: 'q147',
    chapter: 1,
    section: '1-2',
    type: 'single',
    difficulty: 2,
    content: '下列关于甲烷的说法正确的是（ ）',
    options: ['A. 甲烷是平面正方形结构', 'B. 甲烷能与溴水发生取代反应', 'C. 甲烷的氯代反应是自由基反应', 'D. 甲烷不能燃烧'],
    correctAnswer: 'C',
    explanation: 'A. 甲烷是正四面体结构，不是平面正方形；B. 甲烷与溴水不反应，与液溴在光照下发生取代反应；C. 甲烷的氯代反应是自由基反应，正确；D. 甲烷能燃烧生成CO₂和H₂O。',
    knowledgePoint: '甲烷的性质',
    tags: ['性质', '甲烷', '一零一中2024', '难度2', '课本P22-26']
  },
  {
    id: 'q148',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 3,
    content: '下列关于醇和酚的说法不正确的是（ ）',
    options: ['A. 醇和酚都含有羟基', 'B. 醇的羟基连接在饱和碳原子上，酚的羟基直接连接在苯环上', 'C. 苯酚的酸性比碳酸强', 'D. 乙醇能与金属钠反应放出氢气'],
    correctAnswer: 'C',
    explanation: 'A. 醇和酚都含有羟基（-OH），正确；B. 醇和酚的结构区别正确；C. 苯酚的酸性弱于碳酸，不能使NaHCO₃放出CO₂，错误；D. 乙醇能与金属钠反应放出氢气，正确。',
    knowledgePoint: '醇和酚的性质',
    tags: ['性质', '醇', '酚', '一零一中2024', '难度3', '课本P61-68']
  },
  {
    id: 'q149',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 4,
    content: '下列有机反应中，属于消去反应的是（ ）',
    options: ['A. 乙烯与溴水反应', 'B. 乙醇与乙酸酯化', 'C. 溴乙烷与NaOH醇溶液共热', 'D. 苯与浓硝酸反应'],
    correctAnswer: 'C',
    explanation: 'A. 乙烯与溴水反应是加成反应；B. 乙醇与乙酸酯化是取代反应；C. 溴乙烷与NaOH醇溶液共热发生消去反应生成乙烯，正确；D. 苯与浓硝酸反应是硝化反应，属于取代反应。',
    knowledgePoint: '反应类型判断',
    tags: ['反应类型', '消去反应', '一零一中2024', '难度4', '课本P65']
  },
  // 理工附中2024
  {
    id: 'q150',
    chapter: 1,
    section: '1-3',
    type: 'single',
    difficulty: 3,
    content: '下列关于烯烃的说法正确的是（ ）',
    options: ['A. 烯烃的通式为CnH₂n，n≥2', 'B. 所有烯烃都能使酸性KMnO₄溶液褪色', 'C. 乙烯是植物生长调节剂', 'D. 聚丙烯是烯烃'],
    correctAnswer: 'A',
    explanation: 'A. 烯烃的通式为CnH₂n，n≥2，正确；B. 烯烃能被酸性KMnO₄氧化，使溶液褪色；C. 乙烯是植物果实的催熟剂，不是生长调节剂；D. 聚丙烯是高分子化合物，属于聚合物，不是烯烃。',
    knowledgePoint: '烯烃的性质',
    tags: ['性质', '烯烃', '理工附中2024', '难度3', '课本P28']
  },
  {
    id: 'q151',
    chapter: 2,
    section: '2-3',
    type: 'single',
    difficulty: 3,
    content: '下列关于乙酸乙酯制备实验的说法正确的是（ ）',
    options: ['A. 反应物是乙酸和乙醇，摩尔比为1:1', 'B. 浓硫酸只作催化剂', 'C. 收集乙酸乙酯时用饱和Na₂CO₃溶液吸收', 'D. 反应温度越高越好'],
    correctAnswer: 'C',
    explanation: 'A. 乙酸和乙醇摩尔比通常为1:1，但为了提高转化率，常使一种反应物过量；B. 浓硫酸既作催化剂又作吸水剂；C. 饱和Na₂CO₃溶液可以吸收乙醇、除去乙酸、降低乙酸乙酯溶解度，正确；D. 温度过高会导致乙醇和乙酸挥发，降低产率。',
    knowledgePoint: '乙酸乙酯的制备',
    tags: ['实验', '酯化反应', '理工附中2024', '难度3', '课本P87']
  },
  {
    id: 'q152',
    chapter: 2,
    section: '2-5',
    type: 'single',
    difficulty: 4,
    content: '由乙醇制备乙二醇，合理的合成路线是（ ）',
    options: ['A. 乙醇→乙烯→1,2-二溴乙烷→乙二醇', 'B. 乙醇→乙醛→乙酸→乙二醇', 'C. 乙醇→乙醚→乙二醇', 'D. 乙醇直接氧化得乙二醇'],
    correctAnswer: 'A',
    explanation: '合成路线：乙醇→乙烯（消去反应）→1,2-二溴乙烷（与Br₂加成）→乙二醇（水解反应）。这是最合理的合成路线。',
    knowledgePoint: '有机合成路线设计',
    tags: ['合成', '路线设计', '理工附中2024', '难度4', '课本P97']
  },
  // 一零一中2024 - 更多题目
  {
    id: 'q153',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 2,
    content: '北京冬奥会的滑雪用品涉及的主要材料中，不属于有机物的是（ ）',
    options: ['A. 滑雪杖——合金', 'B. 滑雪板——聚乙烯', 'C. 滑雪头盔——聚氯乙烯', 'D. 防护镜——聚甲基丙烯酸甲酯'],
    correctAnswer: 'A',
    explanation: '合金是金属材料，属于无机物；聚乙烯、聚氯乙烯、聚甲基丙烯酸甲酯都是有机高分子材料。',
    knowledgePoint: '有机物与无机物的区分',
    tags: ['基础概念', '有机物', '一零一中2024', '难度2', '课本P2']
  },
  {
    id: 'q154',
    chapter: 1,
    section: '1-3',
    type: 'single',
    difficulty: 2,
    content: '下列变化中发生了加成反应的是（ ）',
    options: ['A. 苯与液溴和铁粉混合', 'B. 乙炔使溴的四氯化碳溶液褪色', 'C. 甲烷和氯气的混合气体光照后颜色变浅', 'D. 灼热的铜丝伸入无水乙醇中'],
    correctAnswer: 'B',
    explanation: 'A. 苯与液溴发生取代反应；B. 乙炔与溴发生加成反应使溴的四氯化碳溶液褪色，正确；C. 甲烷与氯气发生取代反应；D. 乙醇在铜催化下发生氧化反应。',
    knowledgePoint: '加成反应的判断',
    tags: ['反应类型', '加成反应', '一零一中2024', '难度2', '课本P29']
  },
  {
    id: 'q155',
    chapter: 2,
    section: '2-3',
    type: 'single',
    difficulty: 3,
    content: '下列说法正确的是（ ）',
    options: ['A. 甲酸与乙二酸互为同系物', 'B. 顺-2-丁烯和反-2-丁烯的加氢产物不同', 'C. CH₃CH₂C≡CCH(CH₃)₂的名称为2-甲基-4-己炔', 'D. 油脂在酸性或碱性条件下均能发生水解反应，但产物不同'],
    correctAnswer: 'D',
    explanation: 'A. 甲酸（HCOOH）与乙二酸（HOOC-COOH）官能团数目不同，不是同系物；B. 顺-2-丁烯和反-2-丁烯加氢都得到丁烷，产物相同；C. 正确名称为5-甲基-2-己炔；D. 油脂酸性水解生成脂肪酸和甘油，碱性水解（皂化）生成脂肪酸盐和甘油，产物不同，正确。',
    knowledgePoint: '有机物性质与命名',
    tags: ['性质', '命名', '一零一中2024', '难度3', '课本P8-89']
  },
  {
    id: 'q156',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 3,
    content: '下列事实不能说明基团间存在影响的是（ ）',
    options: ['A. 乙烯能使酸性高锰酸钾溶液褪色而乙烷不能', 'B. 甲苯能使酸性高锰酸钾溶液褪色而甲烷不能', 'C. 苯酚能与NaOH溶液反应而苯甲醇不能', 'D. 氯乙酸(ClCH₂COOH)的酸性强于乙酸'],
    correctAnswer: 'A',
    explanation: 'A. 乙烯能使酸性KMnO₄褪色是因为含有碳碳双键，乙烷不能是因为没有不饱和键，这是官能团本身的性质，不是基团间相互影响的结果；B、C、D都说明了基团间的相互影响。',
    knowledgePoint: '基团间的相互影响',
    tags: ['结构', '基团影响', '一零一中2024', '难度3', '课本P41']
  },
  {
    id: 'q157',
    chapter: 2,
    section: '2-3',
    type: 'experiment',
    difficulty: 4,
    content: '某同学利用装置制备乙酸乙酯，实验过程中试管B中红色溶液上方出现油状液体，振荡后油状液体层变薄，下层红色溶液褪色。下列说法正确的是（ ）',
    options: ['A. 加热温度越高越好', 'B. 油状液体层变薄主要是乙酸乙酯溶于Na₂CO₃溶液所致', 'C. 红色褪去的原因可能是酚酞溶于乙酸乙酯中', 'D. 上层油状液体核磁共振氢谱共有3组峰'],
    correctAnswer: 'C',
    explanation: 'A. 温度过高会导致乙醇和乙酸挥发，降低产率；B. 油状液体层变薄是因为乙酸乙酯中的乙酸和乙醇被Na₂CO₃溶液吸收；C. 酚酞是有机物，可能溶于乙酸乙酯中导致红色褪去，正确；D. 乙酸乙酯的核磁共振氢谱有3组峰，但上层油状液体可能含有杂质。',
    knowledgePoint: '乙酸乙酯的制备实验',
    tags: ['实验', '酯化反应', '一零一中2024', '难度4', '课本P87']
  },
  // 填空题和计算题
  {
    id: 'q158',
    chapter: 1,
    section: '1-2',
    type: 'fill',
    difficulty: 2,
    content: '甲烷的分子式为______，电子式为______，空间构型为______。',
    options: [],
    correctAnswer: 'CH4；H:C:H（四面体）；正四面体',
    explanation: '甲烷是最简单的烃，分子式为CH₄，碳原子与四个氢原子以共价键相连，呈正四面体结构，键角约为109.5°。',
    knowledgePoint: '甲烷的结构',
    tags: ['基础概念', '甲烷', '难度2', '课本P22']
  },
  {
    id: 'q159',
    chapter: 1,
    section: '1-3',
    type: 'fill',
    difficulty: 2,
    content: '乙烯的结构简式为______，官能团是______，乙烯使溴水褪色的反应类型是______。',
    options: [],
    correctAnswer: 'CH₂=CH₂；碳碳双键；加成反应',
    explanation: '乙烯含有碳碳双键，结构简式为CH₂=CH₂，能与溴水发生加成反应使溴水褪色。',
    knowledgePoint: '乙烯的结构与性质',
    tags: ['结构', '乙烯', '难度2', '课本P28']
  },
  {
    id: 'q160',
    chapter: 2,
    section: '2-1',
    type: 'fill',
    difficulty: 2,
    content: '乙醇的官能团是______，乙醇与金属钠反应的化学方程式为______。',
    options: [],
    correctAnswer: '羟基(-OH)；2CH₃CH₂OH + 2Na → 2CH₃CH₂ONa + H₂↑',
    explanation: '乙醇含有羟基（-OH），羟基上的氢原子活泼，能与金属钠反应生成乙醇钠和氢气。',
    knowledgePoint: '乙醇的性质',
    tags: ['性质', '乙醇', '难度2', '课本P63']
  },
  {
    id: 'q161',
    chapter: 2,
    section: '2-2',
    type: 'fill',
    difficulty: 3,
    content: '乙醛的官能团是______，乙醛发生银镜反应的化学方程式为______。',
    options: [],
    correctAnswer: '醛基(-CHO)；CH₃CHO + 2[Ag(NH₃)₂]OH → CH₃COONH₄ + 2Ag↓ + 3NH₃ + H₂O',
    explanation: '乙醛含有醛基（-CHO），能与银氨溶液发生银镜反应，乙醛被氧化为乙酸铵，Ag⁺被还原为Ag。',
    knowledgePoint: '乙醛的性质',
    tags: ['性质', '乙醛', '难度3', '课本P77']
  },
  {
    id: 'q162',
    chapter: 1,
    section: '1-2',
    type: 'calculation',
    difficulty: 3,
    content: '标准状况下，11.2L甲烷完全燃烧，生成二氧化碳的质量是多少克？',
    options: [],
    correctAnswer: '22g',
    explanation: '甲烷燃烧反应：CH₄ + 2O₂ → CO₂ + 2H₂O。11.2L甲烷为0.5mol，生成0.5mol CO₂，质量为0.5 × 44 = 22g。',
    knowledgePoint: '甲烷燃烧计算',
    tags: ['计算', '燃烧', '难度3', '课本P27']
  },
  {
    id: 'q163',
    chapter: 2,
    section: '2-2',
    type: 'calculation',
    difficulty: 4,
    content: '某饱和一元醛0.1mol与足量银氨溶液反应，生成21.6g银，该醛的分子式是______。',
    options: [],
    correctAnswer: 'C₂H₄O（乙醛）',
    explanation: '21.6g Ag为0.2mol。R-CHO + 2[Ag(NH₃)₂]OH → R-COONH₄ + 2Ag↓ + 3NH₃ + H₂O，1mol醛生成2mol Ag。0.1mol醛生成0.2mol Ag，符合题意。饱和一元醛通式为CnH₂nO，乙醛为C₂H₄O。',
    knowledgePoint: '醛的计算',
    tags: ['计算', '醛', '难度4', '课本P77']
  },
  // 更多判断题
  {
    id: 'q164',
    chapter: 1,
    section: '1-1',
    type: 'judge',
    difficulty: 1,
    content: '判断：所有有机物都含有碳元素。（ ）',
    options: ['正确', '错误'],
    correctAnswer: '正确',
    explanation: '有机物是含碳的化合物（除CO、CO₂、碳酸盐等少数简单含碳化合物外），所以所有有机物都含有碳元素。',
    knowledgePoint: '有机物的定义',
    tags: ['基础概念', '有机物', '难度1', '课本P2']
  },
  {
    id: 'q165',
    chapter: 1,
    section: '1-3',
    type: 'judge',
    difficulty: 2,
    content: '判断：乙烯和乙炔都能使酸性KMnO₄溶液褪色，原理相同。（ ）',
    options: ['正确', '错误'],
    correctAnswer: '正确',
    explanation: '乙烯和乙炔都含有不饱和键，都能被酸性KMnO₄氧化，使溶液褪色，原理都是氧化反应。',
    knowledgePoint: '烯烃和炔烃的性质',
    tags: ['性质', '烯烃', '炔烃', '难度2', '课本P29-33']
  },
  {
    id: 'q166',
    chapter: 2,
    section: '2-3',
    type: 'judge',
    difficulty: 2,
    content: '判断：乙酸乙酯在碱性条件下的水解反应称为皂化反应。（ ）',
    options: ['正确', '错误'],
    correctAnswer: '错误',
    explanation: '皂化反应特指油脂在碱性条件下的水解反应，生成高级脂肪酸盐（肥皂）。乙酸乙酯的水解不是皂化反应。',
    knowledgePoint: '皂化反应',
    tags: ['概念', '皂化反应', '难度2', '课本P89']
  },

  // ============================================
  // 继续添加更多试卷题目 (q167-q200)
  // 来源：清华附中2024、一零一中2024
  // ============================================

  // 清华附中2024 选择题
  {
    id: 'q167',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 2,
    content: '下列有关乙醇的表述不正确的是（ ）\nA. 乙醇的实验式和分子式均为C₂H₆O\nB. 乙醇分子的空间填充模型为\nC. 乙醇分子中官能团的电子式为\nD. 乙醇与二甲基醚互为同分异构体',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'A',
    explanation: '乙醇的分子式是C₂H₆O，实验式（最简式）是C₂H₆O，但表述"均为C₂H₆O"虽然数值相同，但概念不同。实际上乙醇实验式应为C₂H₆O，分子式也是C₂H₆O。此题主要考查对乙醇结构的理解。',
    knowledgePoint: '乙醇的结构与性质',
    tags: ['清华附中2024', '难度2', '课本P62-63', '醇类']
  },
  {
    id: 'q168',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 3,
    content: '下列有机物的系统命名正确的是（ ）\nA. 2-乙基丁烷\nB. 3,3-二甲基丁烷\nC. 2-甲基-1,3-丁二烯\nD. 2,2-二甲基-3-戊炔',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'C',
    explanation: 'A选项主链选择错误，应为3-甲基戊烷；B选项编号错误，应为2,2-二甲基丁烷；D选项编号错误，应为4,4-二甲基-2-戊炔。C选项2-甲基-1,3-丁二烯命名正确。',
    knowledgePoint: '有机物的系统命名',
    tags: ['清华附中2024', '难度3', '课本P8-10', '命名']
  },
  {
    id: 'q169',
    chapter: 2,
    section: '2-3',
    type: 'single',
    difficulty: 2,
    content: '下列物质的用途中，不正确的是（ ）\nA. 醋酸可除水垢\nB. 乙烯可用于催熟果实\nC. 丙三醇可用于配制化妆品\nD. 油脂在酸性条件下水解用于制作肥皂',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'D',
    explanation: '油脂在碱性条件下的水解反应称为皂化反应，用于制作肥皂。酸性条件下水解生成高级脂肪酸和甘油，不能用于制肥皂。',
    knowledgePoint: '油脂的性质与用途',
    tags: ['清华附中2024', '难度2', '课本P89', '油脂']
  },
  {
    id: 'q170',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 2,
    content: '下列有机物中，由于分子之间易形成氢键，沸点较高的是（ ）\nA. 乙烷\nB. 乙醇\nC. 乙酸乙酯\nD. 甲苯',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'B',
    explanation: '乙醇分子中含有-OH羟基，分子间能形成氢键，使沸点显著升高。乙烷、乙酸乙酯、甲苯分子间都不能形成氢键。',
    knowledgePoint: '氢键对沸点的影响',
    tags: ['清华附中2024', '难度2', '课本P62', '氢键']
  },
  {
    id: 'q171',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 3,
    content: '下列过程中没有发生取代反应的是（ ）\nA. 油脂的水解\nB. 甲苯制TNT的反应\nC. 乙醛的银镜反应\nD. 白酒在陈化过程中产生香味',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'C',
    explanation: '乙醛的银镜反应是氧化反应，不是取代反应。油脂水解、甲苯硝化制TNT、白酒陈化（酯化反应）都是取代反应。',
    knowledgePoint: '有机反应类型判断',
    tags: ['清华附中2024', '难度3', '课本P75-80', '反应类型']
  },
  {
    id: 'q172',
    chapter: 1,
    section: '1-3',
    type: 'single',
    difficulty: 3,
    content: '有8种物质：①乙烷；②乙烯；③乙炔；④苯；⑤甲苯；⑥溴乙烷；⑦聚丙烯；⑧环己烯。其中既不能使酸性KMnO₄溶液褪色，也不能与溴水反应而使溴水褪色的是（ ）\nA. ①②③⑤\nB. ①④⑥⑦\nC. ④⑥⑦⑧\nD. ②③⑤⑧',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'B',
    explanation: '乙烷、苯、溴乙烷、聚丙烯既不能使酸性KMnO₄褪色，也不能与溴水反应。乙烯、乙炔、环己烯含不饱和键，能使两者褪色；甲苯能使KMnO₄褪色。',
    knowledgePoint: '烃的性质',
    tags: ['清华附中2024', '难度3', '课本P29-45', '性质鉴别']
  },
  {
    id: 'q173',
    chapter: 1,
    section: '1-4',
    type: 'single',
    difficulty: 3,
    content: '下列关于苯的叙述正确的是（ ）\nA. 反应①为取代反应，反应的试剂是浓溴水\nB. 反应②为氧化反应，反应现象是火焰明亮并带有浓烟\nC. 反应③为取代反应，有机产物是炸药TNT\nD. 反应④中1mol苯最多与3mol H₂发生加成反应，是因为苯分子中含有三个碳碳双键',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'B',
    explanation: '苯的燃烧是氧化反应，由于含碳量高，火焰明亮并带有浓烟。A选项苯与溴反应需用液溴和催化剂；C选项TNT是三硝基甲苯，不是苯的产物；D选项苯分子中不含碳碳双键。',
    knowledgePoint: '苯的性质',
    tags: ['清华附中2024', '难度3', '课本P41-43', '芳香烃']
  },
  {
    id: 'q174',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 3,
    content: '由2-氯丙烷制取少量的1,2-丙二醇时，需要经过下列哪几步反应（ ）\nA. 加成→消去→取代\nB. 消去→加成→水解\nC. 取代→消去→加成\nD. 消去→加成→消去',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'B',
    explanation: '2-氯丙烷先消去生成丙烯，丙烯与卤素加成生成1,2-二卤丙烷，再水解生成1,2-丙二醇。路线为：消去→加成→水解。',
    knowledgePoint: '有机合成路线',
    tags: ['清华附中2024', '难度3', '课本P95-97', '合成路线']
  },
  {
    id: 'q175',
    chapter: 1,
    section: '1-4',
    type: 'single',
    difficulty: 4,
    content: '下列说法正确的是（ ）\nA. 甲苯中含有两种不同环境的氢原子\nB. 顺-2-丁烯与反-2-丁烯与氢气的加成产物不同\nC. 2-丙醇在铜催化下能被氧气氧化为醛\nD. CH₃-C≡C-CH₃中的所有碳原子均处在同一直线上',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'D',
    explanation: '2-丁炔(CH₃-C≡C-CH₃)是直线形分子，所有碳原子共线。A选项甲苯有4种氢；B选项顺反异构体加氢产物相同（都是丁烷）；C选项2-丙醇氧化生成酮（丙酮），不是醛。',
    knowledgePoint: '有机物结构与性质',
    tags: ['清华附中2024', '难度4', '课本P33-45', '结构']
  },
  {
    id: 'q176',
    chapter: 1,
    section: '1-4',
    type: 'single',
    difficulty: 4,
    content: '下列对实验事实的解释不正确的是（ ）\n\n| 选项 | 实验事实 | 解释 |\n|------|----------|------|\n| A | 甲苯能使酸性KMnO₄溶液褪色但苯不能 | 甲基使苯环上的部分H活化 |\n| B | 甲苯生成邻硝基甲苯比苯生成硝基苯所需温度低 | 甲基使苯环上的部分H活化 |\n| C | 苯酚能和浓溴水反应产生白色沉淀但苯不能 | 羟基使苯环上的部分H活化 |\n| D | 常温下苯酚与NaOH反应而环己醇不能 | 苯环使羟基的O-H键极性增强 |',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'A',
    explanation: '甲苯使酸性KMnO₄褪色是因为甲基被氧化，不是苯环上的H被活化。B、C、D选项的解释都是正确的。',
    knowledgePoint: '基团间的相互影响',
    tags: ['清华附中2024', '难度4', '课本P70-71', '基团影响']
  },

  // 一零一中2024 选择题
  {
    id: 'q177',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 1,
    content: '北京冬奥会的成功举办，极大程度促进了我国群众参与冰雪运动。下列滑雪用品涉及的主要材料中，不属于有机物的是（ ）\nA. 滑雪杖——合金\nB. 滑雪板——聚乙烯\nC. 滑雪头盔——聚氯乙烯\nD. 防护镜——聚甲基丙烯酸甲酯',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'A',
    explanation: '合金是金属材料，属于无机物。聚乙烯、聚氯乙烯、聚甲基丙烯酸甲酯都是有机高分子材料。',
    knowledgePoint: '有机物与无机物的判断',
    tags: ['一零一中2024', '难度1', '课本P2', '材料']
  },
  {
    id: 'q178',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 2,
    content: '下列化学用语表达不正确的是（ ）\nA. 丁酸的实验式：C₂H₄O\nB. 羟基的电子式：·O:H\nC. 乙炔的分子结构模型：直线形\nD. 丙醛的结构简式：CH₃CH₂CHO',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'B',
    explanation: '羟基(-OH)的电子式应该是·Ö:H（氧原子有一个未成对电子）。其他选项均正确。',
    knowledgePoint: '化学用语',
    tags: ['一零一中2024', '难度2', '课本P4-6', '化学用语']
  },
  {
    id: 'q179',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 2,
    content: '下列变化中发生了加成反应的是（ ）\nA. 苯与液溴和铁粉混合\nB. 乙炔使溴的四氯化碳溶液褪色\nC. 甲烷和氯气的混合气体光照后颜色变浅\nD. 灼热的铜丝伸入无水乙醇中',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'B',
    explanation: '乙炔与溴发生加成反应使溴的四氯化碳溶液褪色。A是取代反应，C是取代反应，D是氧化反应。',
    knowledgePoint: '加成反应的判断',
    tags: ['一零一中2024', '难度2', '课本P33-34', '加成反应']
  },
  {
    id: 'q180',
    chapter: 1,
    section: '1-1',
    type: 'single',
    difficulty: 3,
    content: '下列说法正确的是（ ）\nA. 甲酸与乙二酸互为同系物\nB. 顺-2-丁烯和反-2-丁烯的加氢产物不同\nC. CH₃CH₂C≡CCH(CH₃)₂的名称为：2-甲基-4-己炔\nD. 油脂在酸性或碱性条件下均能发生水解反应，但产物不同',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'D',
    explanation: '油脂在酸性条件下水解生成高级脂肪酸和甘油，在碱性条件下水解生成高级脂肪酸盐（肥皂）和甘油，产物不同。A选项官能团数目不同，不是同系物；B选项加氢产物相同（都是丁烷）；C选项命名错误，应为5-甲基-2-己炔。',
    knowledgePoint: '有机物结构与命名',
    tags: ['一零一中2024', '难度3', '课本P8-10', '同系物']
  },
  {
    id: 'q181',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 3,
    content: '下列事实不能说明基团间存在影响的是（ ）\nA. 乙烯能使酸性高锰酸钾溶液褪色而乙烷不能\nB. 甲苯能使酸性高锰酸钾溶液褪色而甲烷不能\nC. 苯酚能与NaOH溶液反应而苯甲醇不能\nD. 氯乙酸(ClCH₂COOH)的酸性强于乙酸',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'A',
    explanation: '乙烯能使KMnO₄褪色是因为含有碳碳双键，这是乙烯自身的性质，不是基团间相互影响的结果。其他选项都体现了基团间的相互影响。',
    knowledgePoint: '基团间的相互影响',
    tags: ['一零一中2024', '难度3', '课本P70-71', '基团影响']
  },
  {
    id: 'q182',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 3,
    content: '某有机物A是农药生产中的一种中间体，其结构简式如图，下列叙述不正确的是（ ）\nA. 有机物A属于芳香族化合物\nB. 有机物A中含有2种含氧官能团\nC. 有机物A既可以发生氧化反应又可以发生还原反应\nD. 1mol有机物A和足量的NaOH溶液反应，最多可以消耗2mol NaOH',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'D',
    explanation: '该有机物含有酚羟基、醛基和氯原子。酚羟基和氯原子水解后生成的HCl都能与NaOH反应，1mol该有机物可消耗3mol NaOH。',
    knowledgePoint: '官能团的性质',
    tags: ['一零一中2024', '难度3', '课本P62-78', '官能团']
  },
  {
    id: 'q183',
    chapter: 2,
    section: '2-3',
    type: 'single',
    difficulty: 3,
    content: '某同学利用装置制备乙酸乙酯。实验如下：①向浓H₂SO₄乙醇混合液中滴入乙酸后，加热试管A；②一段时间后，试管B中红色溶液上方出现油状液体；③停止加热，振荡试管B，油状液体层变薄，下层红色溶液褪色；④取下层褪色后的溶液，滴入酚酞后又出现红色。结合上述实验，下列说法正确的是（ ）\nA. ①中加热利于加快酯化反应速率，故温度越高越好\nB. ③中油状液体层变薄主要是乙酸乙酯溶于Na₂CO₃溶液所致\nC. ③中红色褪去的原因可能是酚酞溶于乙酸乙酯中\nD. 取②中上层油状液体测其核磁共振氢谱，共有3组峰',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'C',
    explanation: '酚酞是有机物，可能溶于乙酸乙酯中导致红色褪去。A选项温度过高会导致副反应；B选项油状液体层变薄主要是因为乙酸乙酯挥发；D选项乙酸乙酯的核磁共振氢谱有3组峰，但上层油状液体可能含有杂质。',
    knowledgePoint: '乙酸乙酯的制备实验',
    tags: ['一零一中2024', '难度3', '课本P85-86', '实验']
  },

  // 填空题
  {
    id: 'q184',
    chapter: 1,
    section: '1-1',
    type: 'fill',
    difficulty: 2,
    content: '有机物CH₃CH(CH₃)CH₂CH₃的系统命名是______。',
    options: [],
    correctAnswer: '2-甲基丁烷',
    explanation: '该有机物主链有4个碳原子，在2号碳上有一个甲基取代基，系统命名为2-甲基丁烷（异戊烷）。',
    knowledgePoint: '烷烃的系统命名',
    tags: ['清华附中2024', '难度2', '课本P8-9', '命名']
  },
  {
    id: 'q185',
    chapter: 1,
    section: '1-3',
    type: 'fill',
    difficulty: 2,
    content: '乙烯分子中碳碳双键的键能______（填"大于"、"小于"或"等于"）乙烷分子中碳碳单键键能的两倍，这是因为碳碳双键中一个是σ键，一个是______键，σ键的键能大于______键。',
    options: [],
    correctAnswer: '小于;π;π',
    explanation: '乙烯分子中碳碳双键的键能小于乙烷分子中碳碳单键键能的两倍，因为碳碳双键中一个是σ键，一个是π键，σ键的键能大于π键。',
    knowledgePoint: '碳碳双键的结构',
    tags: ['清华附中2024', '难度2', '课本P29', '结构']
  },
  {
    id: 'q186',
    chapter: 2,
    section: '2-2',
    type: 'fill',
    difficulty: 3,
    content: '乙醛与新制Cu(OH)₂悬浊液反应的化学方程式为：CH₃CHO + 2Cu(OH)₂ + NaOH →______ + Cu₂O↓ + 3H₂O',
    options: [],
    correctAnswer: 'CH₃COONa',
    explanation: '乙醛被新制Cu(OH)₂氧化生成乙酸，乙酸与NaOH反应生成乙酸钠(CH₃COONa)。',
    knowledgePoint: '醛的氧化反应',
    tags: ['清华附中2024', '难度3', '课本P74', '醛类']
  },
  {
    id: 'q187',
    chapter: 2,
    section: '2-3',
    type: 'fill',
    difficulty: 2,
    content: '乙酸乙酯在酸性条件下水解的化学方程式为：CH₃COOCH₂CH₃ + H₂O ⇌ ______ + ______',
    options: [],
    correctAnswer: 'CH₃COOH;CH₃CH₂OH',
    explanation: '乙酸乙酯在酸性条件下水解生成乙酸(CH₃COOH)和乙醇(CH₃CH₂OH)，反应可逆。',
    knowledgePoint: '酯的水解反应',
    tags: ['一零一中2024', '难度2', '课本P88-89', '酯类']
  },
  {
    id: 'q188',
    chapter: 1,
    section: '1-3',
    type: 'fill',
    difficulty: 3,
    content: '丙烯与HCl发生加成反应，主要产物是______（写结构简式），该反应遵循______规则。',
    options: [],
    correctAnswer: 'CH₃CHClCH₃;马氏',
    explanation: '丙烯与HCl加成主要生成2-氯丙烷(CH₃CHClCH₃)，遵循马氏规则（氢加在含氢较多的碳原子上）。',
    knowledgePoint: '烯烃的加成反应',
    tags: ['清华附中2024', '难度3', '课本P31', '马氏规则']
  },

  // 判断题
  {
    id: 'q189',
    chapter: 1,
    section: '1-4',
    type: 'judge',
    difficulty: 2,
    content: '判断：苯分子中的碳碳键是介于单键和双键之间的独特的键，因此苯既能发生取代反应，又能发生加成反应。（ ）',
    options: ['正确', '错误'],
    correctAnswer: '正确',
    explanation: '苯分子中的碳碳键是特殊的键，具有部分双键性质，能发生加成反应；同时苯环上的氢能被取代，发生取代反应。',
    knowledgePoint: '苯的结构与性质',
    tags: ['清华附中2024', '难度2', '课本P41-43', '苯']
  },
  {
    id: 'q190',
    chapter: 2,
    section: '2-1',
    type: 'judge',
    difficulty: 2,
    content: '判断：乙醇和二甲醚互为同分异构体，它们的官能团相同。（ ）',
    options: ['正确', '错误'],
    correctAnswer: '错误',
    explanation: '乙醇(CH₃CH₂OH)和二甲醚(CH₃OCH₃)分子式相同(C₂H₆O)，互为同分异构体，但官能团不同：乙醇含羟基(-OH)，二甲醚含醚键(-O-)。',
    knowledgePoint: '同分异构体',
    tags: ['清华附中2024', '难度2', '课本P62', '同分异构']
  },
  {
    id: 'q191',
    chapter: 2,
    section: '2-2',
    type: 'judge',
    difficulty: 3,
    content: '判断：乙醛既能发生银镜反应，又能与氢气发生加成反应，因此乙醛既有氧化性又有还原性。（ ）',
    options: ['正确', '错误'],
    correctAnswer: '正确',
    explanation: '乙醛发生银镜反应时被氧化，体现还原性；与氢气加成时被还原，体现氧化性。因此乙醛既有氧化性又有还原性。',
    knowledgePoint: '醛的性质',
    tags: ['一零一中2024', '难度3', '课本P73-74', '醛类']
  },
  {
    id: 'q192',
    chapter: 2,
    section: '2-3',
    type: 'judge',
    difficulty: 2,
    content: '判断：乙酸和乙醇发生酯化反应时，乙酸脱去羟基，乙醇脱去氢原子。（ ）',
    options: ['正确', '错误'],
    correctAnswer: '正确',
    explanation: '酯化反应的机理是"酸脱羟基醇脱氢"，乙酸脱去-OH，乙醇脱去-H，生成乙酸乙酯和水。',
    knowledgePoint: '酯化反应机理',
    tags: ['一零一中2024', '难度2', '课本P85', '酯化反应']
  },

  // 计算题
  {
    id: 'q193',
    chapter: 1,
    section: '1-2',
    type: 'calculation',
    difficulty: 3,
    content: '某烷烃0.1mol完全燃烧，生成8.96L CO₂（标准状况）和9.0g H₂O。\n(1) 求该烷烃的分子式；\n(2) 写出该烷烃可能的结构简式。',
    options: [],
    correctAnswer: 'C₄H₁₀; CH₃CH₂CH₂CH₃或CH₃CH(CH₃)₂',
    explanation: '(1) n(CO₂)=8.96/22.4=0.4mol，n(H₂O)=9.0/18=0.5mol。0.1mol烷烃含0.4mol C和1.0mol H，分子式为C₄H₁₀。\n(2) 丁烷有两种同分异构体：正丁烷CH₃CH₂CH₂CH₃和异丁烷CH₃CH(CH₃)₂。',
    knowledgePoint: '烷烃的燃烧计算',
    tags: ['清华附中2024', '难度3', '课本P24-25', '计算']
  },
  {
    id: 'q194',
    chapter: 2,
    section: '2-2',
    type: 'calculation',
    difficulty: 4,
    content: '某饱和一元醛3.6g与足量银氨溶液反应，生成10.8g银。\n(1) 求该醛的相对分子质量；\n(2) 写出该醛的结构简式。',
    options: [],
    correctAnswer: '58; CH₃CH₂CHO',
    explanation: '(1) n(Ag)=10.8/108=0.1mol。一元醛与银氨溶液反应：RCHO + 2[Ag(NH₃)₂]OH → RCOONH₄ + 2Ag↓ + 3NH₃ + H₂O。n(醛)=0.1/2=0.05mol，M=3.6/0.05=58。\n(2) 饱和一元醛通式CₙH₂ₙO，14n+16=58，n=3，为丙醛CH₃CH₂CHO。',
    knowledgePoint: '醛的银镜反应计算',
    tags: ['一零一中2024', '难度4', '课本P74', '计算']
  },

  // 实验题
  {
    id: 'q195',
    chapter: 2,
    section: '2-3',
    type: 'experiment',
    difficulty: 3,
    content: '实验室制取乙酸乙酯的实验中：\n(1) 浓硫酸的作用是______和______；\n(2) 饱和Na₂CO₃溶液的作用是：①吸收乙醇；②______；③______；\n(3) 导管不能插入液面以下的原因是______。',
    options: [],
    correctAnswer: '催化剂;吸水剂;中和乙酸;降低乙酸乙酯的溶解度;防止倒吸',
    explanation: '(1) 浓硫酸作催化剂和吸水剂；\n(2) 饱和Na₂CO₃溶液作用：吸收乙醇、中和乙酸、降低乙酸乙酯的溶解度便于分层；\n(3) 导管不插入液面以下是防止倒吸。',
    knowledgePoint: '乙酸乙酯的制备实验',
    tags: ['一零一中2024', '难度3', '课本P85-86', '实验']
  },
  {
    id: 'q196',
    chapter: 1,
    section: '1-3',
    type: 'experiment',
    difficulty: 4,
    content: '某同学设计实验验证乙烯的化学性质，装置如图所示。\n(1) 装置A中发生反应的化学方程式为______；\n(2) 装置B中试剂的作用是______；\n(3) 装置C中观察到的现象是______，说明乙烯具有______性。',
    options: [],
    correctAnswer: 'CH₃CH₂OH →(浓H₂SO₄,170℃)→ CH₂=CH₂↑ + H₂O;除去乙烯中混有的SO₂等杂质;酸性KMnO₄溶液褪色;还原',
    explanation: '(1) 乙醇在浓硫酸170℃条件下发生消去反应生成乙烯；\n(2) NaOH溶液用于除去乙烯中混有的SO₂等杂质气体；\n(3) 乙烯使酸性KMnO₄溶液褪色，体现还原性。',
    knowledgePoint: '乙烯的制备与性质实验',
    tags: ['清华附中2024', '难度4', '课本P36-37', '实验']
  },

  // 有机推断题
  {
    id: 'q197',
    chapter: 2,
    section: '2-5',
    type: 'reasoning',
    difficulty: 4,
    content: '已知A是石油裂解气的主要成分之一，其产量可以用来衡量一个国家的石油化工发展水平。以A为原料可以合成多种有机物，转化关系如下：\nA →(H₂O,催化剂)→ B →(O₂,Cu,△)→ C →(O₂,催化剂)→ D\n其中B、C、D均为含氧衍生物。\n(1) A的结构简式为______；\n(2) B → C的反应类型为______；\n(3) C → D的化学方程式为______。',
    options: [],
    correctAnswer: 'CH₂=CH₂;氧化反应;2CH₃CHO + O₂ →(催化剂,△)→ 2CH₃COOH',
    explanation: 'A为乙烯(CH₂=CH₂)，B为乙醇(CH₃CH₂OH)，C为乙醛(CH₃CHO)，D为乙酸(CH₃COOH)。\n(1) A是乙烯，结构简式CH₂=CH₂；\n(2) 乙醇氧化生成乙醛，是氧化反应；\n(3) 乙醛氧化生成乙酸。',
    knowledgePoint: '有机推断',
    tags: ['清华附中2024', '难度4', '课本P95-97', '推断']
  },
  {
    id: 'q198',
    chapter: 2,
    section: '2-5',
    type: 'reasoning',
    difficulty: 5,
    content: '某芳香族化合物A的分子式为C₈H₈O₂，其核磁共振氢谱显示有4组峰，峰面积之比为3:2:2:1。A可以发生如下转化：\nA →(NaOH溶液,△)→ B →(HCl)→ C\n已知C能与FeCl₃溶液发生显色反应。\n(1) A的结构简式为______；\n(2) A与NaOH溶液反应的化学方程式为______；\n(3) C的同分异构体中，属于芳香族化合物且能与NaHCO₃反应的有______种。',
    options: [],
    correctAnswer: 'CH₃COOC₆H₅;CH₃COOC₆H₅ + NaOH → CH₃COONa + C₆H₅OH;4',
    explanation: 'A为乙酸苯酯(CH₃COOC₆H₅)，水解生成乙酸钠和苯酚。C为苯酚，能与FeCl₃显色。\n(3) 能与NaHCO₃反应说明含-COOH，分子式C₆H₅OH的同分异构体中：苯甲酸、邻羟基苯甲酸、间羟基苯甲酸、对羟基苯甲酸，共4种。',
    knowledgePoint: '有机推断与同分异构体',
    tags: ['一零一中2024', '难度5', '课本P95-97', '推断']
  },

  // 更多选择题
  {
    id: 'q199',
    chapter: 2,
    section: '2-1',
    type: 'single',
    difficulty: 3,
    content: '下列关于醇类的说法正确的是（ ）\nA. 所有醇类都能被氧化为醛或酮\nB. 醇类都能与金属钠反应放出氢气\nC. 醇类的沸点都低于相应的烷烃\nD. 醇类都能发生消去反应生成烯烃',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'B',
    explanation: '所有醇类都含有-OH，都能与金属钠反应放出氢气。A选项叔醇不能被氧化为醛或酮；C选项醇类因能形成氢键，沸点高于相应烷烃；D选项只有β位有氢的醇才能发生消去反应。',
    knowledgePoint: '醇的性质',
    tags: ['清华附中2024', '难度3', '课本P62-65', '醇类']
  },
  {
    id: 'q200',
    chapter: 2,
    section: '2-4',
    type: 'single',
    difficulty: 3,
    content: '下列反应中，属于消去反应的是（ ）\nA. 乙醇与乙酸反应生成乙酸乙酯\nB. 溴乙烷与NaOH水溶液反应生成乙醇\nC. 乙醇与浓硫酸混合加热至170℃生成乙烯\nD. 乙醛与氢气反应生成乙醇',
    options: ['A', 'B', 'C', 'D'],
    correctAnswer: 'C',
    explanation: '乙醇在浓硫酸170℃条件下发生消去反应生成乙烯和水。A是酯化反应（取代），B是水解反应（取代），D是加成反应（还原）。',
    knowledgePoint: '消去反应的判断',
    tags: ['一零一中2024', '难度3', '课本P64', '消去反应']
  },

];

// 根据小节分配题目ID
const getQuestionsBySection = (section: string): string[] => {
  return questions.filter(q => q.section === section).map(q => q.id);
};

export const levels: Level[] = [
  // 第一章 - 全部开放
  { id: 1, title: '1-1 有机化合物分类与命名', description: '基础概念，轻松上手', chapter: 1, difficulty: 2, requiredScore: 60, questions: getQuestionsBySection('1-1'), unlocked: true, stars: 0, bestScore: 0, completed: false },
  { id: 2, title: '1-2 烷烃的性质与反应', description: '烷烃结构、性质与反应', chapter: 1, difficulty: 2, requiredScore: 60, questions: getQuestionsBySection('1-2'), unlocked: true, stars: 0, bestScore: 0, completed: false },
  { id: 3, title: '1-3 烯烃与炔烃', description: '不饱和烃的性质与反应', chapter: 1, difficulty: 3, requiredScore: 60, questions: getQuestionsBySection('1-3'), unlocked: true, stars: 0, bestScore: 0, completed: false },
  { id: 4, title: '1-4 芳香烃与苯环', description: '苯及其同系物的性质', chapter: 1, difficulty: 3, requiredScore: 60, questions: getQuestionsBySection('1-4'), unlocked: true, stars: 0, bestScore: 0, completed: false },
  { id: 5, title: '1-5 石油、煤的综合利用', description: '化石燃料的综合应用', chapter: 1, difficulty: 2, requiredScore: 60, questions: getQuestionsBySection('1-5'), unlocked: true, stars: 0, bestScore: 0, completed: false },
  // 第二章 - 全部开放
  { id: 6, title: '2-1 醇、酚、醚的性质', description: '含氧衍生物的性质', chapter: 2, difficulty: 3, requiredScore: 60, questions: getQuestionsBySection('2-1'), unlocked: true, stars: 0, bestScore: 0, completed: false },
  { id: 7, title: '2-2 醛、酮的结构与性质', description: '羰基化合物的性质', chapter: 2, difficulty: 3, requiredScore: 60, questions: getQuestionsBySection('2-2'), unlocked: true, stars: 0, bestScore: 0, completed: false },
  { id: 8, title: '2-3 羧酸、酯的性质', description: '羧酸和酯的性质与应用', chapter: 2, difficulty: 3, requiredScore: 60, questions: getQuestionsBySection('2-3'), unlocked: true, stars: 0, bestScore: 0, completed: false },
  { id: 9, title: '2-4 有机反应类型', description: '取代、加成、消去等反应', chapter: 2, difficulty: 3, requiredScore: 60, questions: getQuestionsBySection('2-4'), unlocked: true, stars: 0, bestScore: 0, completed: false },
  { id: 10, title: '2-5 有机合成路线设计', description: '有机合成方法与路线', chapter: 2, difficulty: 4, requiredScore: 60, questions: getQuestionsBySection('2-5'), unlocked: true, stars: 0, bestScore: 0, completed: false }
];

import { Achievement } from '../types';

export const achievements: Achievement[] = [
  { id: 'first_win', title: '初次胜利', description: '完成第一关挑战', icon: '🏆', requirement: 'complete', unlocked: false },
  { id: 'perfect_score', title: '满分达人', description: '获得满分评价', icon: '⭐', requirement: 'score', unlocked: false },
  { id: 'speed_runner', title: '速通高手', description: '快速完成挑战', icon: '⚡', requirement: 'speed', unlocked: false },
  { id: 'master_chemist', title: '化学大师', description: '完成所有关卡', icon: '🔬', requirement: 'complete_all', unlocked: false }
];
